var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _g3, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _g4, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _g5, _path315, _path316, _path317, _g6, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureNew2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1570,
    height: 1111,
    viewBox: "0 0 1570 1111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M558.364 924.763C534.822 924.763 510.979 919.633 493.171 909.069L346.187 824.259C328.078 813.997 318.42 799.811 318.42 784.721C318.42 769.63 328.38 755.746 346.187 745.183L904.245 422.843C940.161 402.018 998.713 402.018 1034.63 422.843L1181.61 507.654C1199.72 517.915 1209.38 532.101 1209.38 547.192C1209.38 562.282 1199.42 576.166 1181.61 586.729L1180.1 584.013L1181.61 586.729L623.556 909.069C605.749 919.633 582.207 924.763 558.364 924.763ZM969.437 413.487C946.801 413.487 924.466 418.316 907.263 428.276L349.205 750.616C333.209 759.972 324.456 772.044 324.456 784.721C324.456 797.397 333.209 809.771 349.205 818.826L496.19 903.636C530.597 923.556 586.433 923.556 620.538 903.636L1178.6 581.297C1194.59 571.94 1203.34 559.868 1203.34 547.192C1203.34 534.515 1194.59 522.141 1178.6 513.086L1031.61 428.276C1014.71 418.618 992.073 413.487 969.437 413.487Z",
    fill: "url(#paint0_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1569.43 768.126L1566.42 773.257L1435.13 697.501C1416.41 686.635 1385.63 686.635 1366.92 697.501C1346.39 709.272 1313.19 709.272 1292.67 697.501L1248.3 671.847C1249.51 674.563 1249.81 676.977 1249.81 679.996C1249.81 688.748 1244.08 697.199 1233.51 703.235L1188.24 729.493C1179.79 734.322 1174.96 740.962 1174.96 747.602C1174.96 754.242 1179.79 760.58 1188.24 765.711L1304.14 832.714L1301.12 837.845L1185.22 770.842C1174.66 764.806 1168.92 756.657 1168.92 747.602C1168.92 738.548 1174.66 730.399 1185.22 724.362L1230.49 698.105C1238.95 693.275 1243.77 686.636 1243.77 679.996C1243.77 673.356 1238.95 667.017 1230.49 661.887L1141.16 610.276L1147.19 606.654L1205.14 640.156V639.854L1295.69 692.068C1314.4 702.934 1345.18 702.934 1363.9 692.068C1384.42 680.297 1417.62 680.297 1438.14 692.068L1569.43 768.126Z",
    fill: "url(#paint1_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.25 577.376L687.231 582.507L555.941 506.751C537.229 495.885 506.444 495.885 487.731 506.751C467.208 518.521 434.008 518.521 413.484 506.751L369.117 481.096C370.325 483.813 370.626 486.227 370.626 489.245C370.626 497.998 364.892 506.449 354.328 512.485L309.056 538.743C300.605 543.572 295.776 550.212 295.776 556.852C295.776 563.492 300.605 569.83 309.056 574.961L424.953 641.964L421.935 647.095L306.038 580.092C295.474 574.056 289.74 565.907 289.74 556.852C289.74 548.099 295.474 539.649 306.038 533.612L351.31 507.354C359.761 502.525 364.59 496.187 364.59 489.245C364.59 482.605 359.761 476.267 351.31 471.136L261.973 419.526L268.009 415.904L325.958 449.406V449.104L416.502 501.318C435.215 512.183 466 512.183 484.713 501.318C505.236 489.547 538.436 489.547 558.96 501.318L690.25 577.376Z",
    fill: "url(#paint2_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.662 959.477C775.081 959.477 761.801 956.458 751.539 950.724L649.827 891.87L652.845 886.739L754.557 945.291C773.27 956.157 804.055 956.157 822.768 945.291L1122.77 772.049L1125.79 777.18L825.484 950.422C815.826 956.458 802.244 959.477 788.662 959.477Z",
    fill: "url(#paint3_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.351 763.897C200.107 763.897 192.864 762.388 187.431 759.068L134.613 728.585L137.631 723.454L190.449 753.937C199.806 759.37 215.198 759.37 224.554 753.937L380.593 663.694L383.611 668.825L227.573 759.068C221.838 762.086 214.595 763.897 207.351 763.897Z",
    fill: "url(#paint4_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.355 940.765C928.075 940.765 914.795 937.747 904.835 932.012L742.458 838.449L745.476 833.318L907.853 926.881C926.264 937.445 956.446 937.445 975.158 926.881L1092.87 858.973C1113.09 847.202 1145.99 847.202 1165.91 858.973L1223.25 891.871L1220.23 897.001L1162.89 864.103C1144.48 853.54 1114.3 853.54 1095.58 864.103L977.875 932.012C967.915 938.048 954.635 940.765 941.355 940.765Z",
    fill: "url(#paint5_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.598 976.377C245.678 983.017 219.722 981.206 202.519 971.548C183.806 960.683 153.021 960.683 134.308 971.548L3.01816 1047L0 1041.87L131.29 966.115C151.813 954.345 185.013 954.345 205.537 966.115C224.249 976.981 255.035 976.981 273.747 966.115L309.663 945.592L336.223 929.897C338.336 930.501 340.448 931.105 342.259 932.312C342.561 932.614 342.863 932.614 343.165 932.916L314.492 949.516L276.463 971.548C273.445 973.359 269.522 974.868 265.598 976.377Z",
    fill: "url(#paint6_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.598 865.91C245.678 872.55 219.722 870.739 202.519 861.081C183.806 850.215 153.021 850.215 134.308 861.081L3.01816 936.837L0 931.706L131.29 855.95C151.813 844.179 185.013 844.179 205.537 855.95C224.249 866.815 255.035 866.815 273.747 855.95L309.663 835.426L336.525 820.034C338.638 820.637 340.75 821.241 342.561 822.448C342.863 822.75 343.165 822.75 343.467 823.052L314.794 839.652L276.765 861.684C273.445 863.194 269.522 864.703 265.598 865.91Z",
    fill: "url(#paint7_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.499 689.656L322.936 635.631C309.657 628.085 288.228 628.085 274.948 635.631C260.159 644.081 236.013 644.081 220.923 635.631L156.334 598.205L159.352 593.075L223.941 630.5C237.221 638.045 258.65 638.045 271.93 630.5C286.719 622.049 310.864 622.049 325.955 630.5L419.518 684.525L416.499 689.656Z",
    fill: "url(#paint8_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.97 389.341L1330.4 335.316C1317.12 327.77 1295.69 327.77 1282.41 335.316C1267.63 343.767 1243.48 343.767 1228.39 335.316L1163.8 297.891L1166.82 292.76L1231.41 330.185C1244.69 337.73 1266.12 337.73 1279.4 330.185C1294.19 321.734 1318.33 321.734 1333.42 330.185L1426.98 384.21L1423.97 389.341Z",
    fill: "url(#paint9_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.386 906.353C885.539 901.826 872.561 901.826 864.714 906.353C856.866 910.88 856.866 918.426 864.714 922.953C872.561 927.48 885.539 927.48 893.386 922.953C901.233 918.124 901.233 910.88 893.386 906.353Z",
    fill: "url(#paint10_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257.69 656.75C1249.84 652.223 1236.86 652.223 1229.02 656.75C1221.17 661.278 1221.17 668.823 1229.02 673.35C1236.86 677.877 1249.84 677.877 1257.69 673.35C1265.53 668.521 1265.53 661.278 1257.69 656.75Z",
    fill: "url(#paint11_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.255 948.913C334.709 953.139 322.637 953.441 314.789 949.517C314.488 949.215 314.186 949.215 313.884 948.913C312.073 948.008 310.866 946.801 309.659 945.593C306.339 941.368 307.546 935.935 313.884 932.615C319.92 928.994 328.975 928.39 336.52 930.201C338.633 930.804 340.746 931.408 342.557 932.615C342.858 932.917 343.16 932.917 343.462 933.219C350.102 937.444 349.8 944.386 342.255 948.913Z",
    fill: "url(#paint12_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.509 1021.04C400.509 1029.8 394.775 1038.25 384.211 1044.28L268.616 1110.98L265.598 1105.85L381.495 1038.85C389.946 1034.02 394.775 1027.38 394.775 1020.74C394.775 1014.1 389.946 1007.76 381.495 1002.63L336.223 976.374C325.659 970.338 319.925 962.189 319.925 953.134C319.925 944.382 325.659 935.931 336.223 929.894L433.407 873.757L439.444 877.077L339.241 935.025C330.79 939.854 325.961 946.192 325.961 953.134C325.961 959.774 330.79 966.112 339.241 971.243L384.513 997.501C394.775 1003.84 400.509 1011.99 400.509 1021.04Z",
    fill: "url(#paint13_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.41 576.47C1378.41 585.222 1372.68 593.673 1362.12 599.709L1246.22 666.713L1243.2 661.582L1359.1 594.579C1367.55 589.75 1372.38 583.11 1372.38 576.47C1372.38 569.83 1367.55 563.492 1359.1 558.361L1313.83 532.103C1303.26 526.066 1297.53 517.917 1297.53 508.863C1297.53 500.11 1303.26 491.659 1313.83 485.623L1411.01 429.485L1417.05 432.805L1316.84 490.754C1308.39 495.583 1303.56 501.921 1303.56 508.863C1303.56 515.503 1308.39 521.841 1316.84 526.972L1362.12 553.23C1372.68 559.266 1378.41 567.415 1378.41 576.47Z",
    fill: "url(#paint14_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.983 677.878C388.152 677.878 397.205 672.607 397.205 666.107C397.205 659.606 388.152 654.336 376.983 654.336C365.815 654.336 356.762 659.606 356.762 666.107C356.762 672.607 365.815 677.878 376.983 677.878Z",
    fill: "url(#paint15_linear_1419_1910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.09 488.341L1142.07 483.21L1225.07 435.221C1232.62 430.996 1236.54 425.563 1236.54 419.828C1236.54 414.094 1232.32 408.661 1225.07 404.436L1131.51 350.411C1122.15 344.978 1117.02 337.734 1117.02 329.585C1117.02 321.436 1122.15 314.193 1131.51 308.76L1222.36 256.244C1240.47 245.681 1270.04 245.681 1288.15 256.244L1343.38 288.237L1340.37 293.367L1285.13 261.375C1268.53 252.019 1241.97 252.019 1225.37 261.375L1134.53 313.891C1126.98 318.116 1123.06 323.549 1123.06 329.284C1123.06 335.018 1127.28 340.451 1134.53 344.676L1228.09 398.701C1237.45 404.134 1242.58 411.378 1242.58 419.527C1242.58 427.374 1237.45 434.919 1228.09 440.352L1145.09 488.341Z",
    fill: "url(#paint16_linear_1419_1910)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1149.04 153.021L1005.07 236.624C999.339 239.944 992.096 239.944 986.361 236.624L791.388 124.349C779.014 117.105 779.014 98.996 791.388 91.7524L935.355 8.14941C941.089 4.82943 948.333 4.82943 954.067 8.14941L1149.04 120.425C1161.41 127.669 1161.41 145.778 1149.04 153.021Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1159.58 489.244V550.512L993.578 646.792V585.825L1159.58 489.244Z",
    fill: "url(#paint17_linear_1419_1910)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M993.586 585.829V646.796L780.806 524.259V462.99L993.586 585.829Z",
    fill: "url(#paint18_linear_1419_1910)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M788.06 520.034L789.267 477.779L985.145 590.659L983.938 632.611L788.06 520.034Z",
    fill: "url(#paint19_linear_1419_1910)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.58 489.246L993.586 585.827L780.806 462.988L992.379 392.966L1159.58 489.246Z",
    fill: "url(#paint20_linear_1419_1910)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M999.034 589.752L1155.98 499.207V546.894L999.034 637.439V589.752Z",
    fill: "#D9E1EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.58 590.96L1069.68 552.931V593.676L1003.58 631.705V590.96Z",
    fill: "#96AAC9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.72 590.658L1006.91 600.92V622.047L1024.72 611.484V590.658Z",
    fill: "#0C65F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.82 578.589L1028.01 588.85V609.978L1045.82 599.414V578.589Z",
    fill: "#0C65F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.37 566.813L1048.26 577.075V597.901L1066.37 587.639V566.813Z",
    fill: "#0C65F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.5 563.794L1126.43 561.379V519.729L1122.5 522.143V563.794Z",
    fill: "#96AAC9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.04 568.318L1118.27 566.205V524.554L1114.04 526.969V568.318Z",
    fill: "#96AAC9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.88 573.152L1110.1 570.737V529.388L1105.88 531.803V573.152Z",
    fill: "#96AAC9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.74 577.978L1101.67 575.564V534.215L1097.74 536.629V577.978Z",
    fill: "#96AAC9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.29 582.805L1093.51 580.39V539.041L1089.29 541.154V582.805Z",
    fill: "#96AAC9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.15 587.638L1085.07 585.223V543.573L1081.15 545.987V587.638Z",
    fill: "#96AAC9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.69 592.464L1076.92 590.05V548.399L1072.69 550.814V592.464Z",
    fill: "#96AAC9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.81 432.204V488.643L993.578 578.283V521.843L1147.81 432.204Z",
    fill: "url(#paint21_linear_1419_1910)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M993.577 521.848V578.287L792.567 462.692V405.95L993.577 521.848Z",
    fill: "#0EB5E3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.8 432.205L993.577 521.844L792.567 405.947L992.37 342.565L1147.8 432.205Z",
    fill: "#15C5F3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.58 366.704V427.671L993.578 524.252V462.983L1159.58 366.704Z",
    fill: "url(#paint22_linear_1419_1910)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M993.586 462.987V524.255L780.806 401.416V340.449L993.586 462.987Z",
    fill: "url(#paint23_linear_1419_1910)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M788.06 397.191L789.267 355.239L985.145 467.816L983.938 510.07L788.06 397.191Z",
    fill: "url(#paint24_linear_1419_1910)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.58 366.706L993.586 462.985L780.806 340.448L992.379 270.125L1159.58 366.706Z",
    fill: "url(#paint25_linear_1419_1910)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M999.034 467.211L1155.98 376.364V424.353L999.034 514.897V467.211Z",
    fill: "#D9E1EE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.58 468.419L1069.68 430.089V470.834L1003.58 509.165V468.419Z",
    fill: "#96AAC9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.72 468.118L1006.91 478.38V499.205L1024.72 488.943V468.118Z",
    fill: "#0C65F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.82 456.048L1028.01 466.31V487.136L1045.82 476.874V456.048Z",
    fill: "#0C65F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.37 443.971L1048.26 454.233V475.36L1066.37 464.797V443.971Z",
    fill: "#0C65F5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.5 440.95L1126.43 438.535V397.187L1122.5 399.299V440.95Z",
    fill: "#96AAC9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.04 445.776L1118.27 443.362V402.013L1114.04 404.126V445.776Z",
    fill: "#96AAC9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.88 450.61L1110.1 448.195V406.544L1105.88 408.959V450.61Z",
    fill: "#96AAC9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.74 455.134L1101.67 453.022V411.371L1097.74 413.785V455.134Z",
    fill: "#96AAC9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.29 459.961L1093.51 457.848V416.198L1089.29 418.612V459.961Z",
    fill: "#96AAC9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.15 464.795L1085.07 462.38V421.031L1081.15 423.446V464.795Z",
    fill: "#96AAC9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.69 469.621L1076.92 467.207V425.858L1072.69 427.971V469.621Z",
    fill: "#96AAC9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.81 308.154V364.594L993.578 454.233V397.793L1147.81 308.154Z",
    fill: "url(#paint26_linear_1419_1910)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M993.577 397.798V454.238L792.567 338.34V281.901L993.577 397.798Z",
    fill: "#0EB5E3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.8 308.155L993.577 397.794L792.567 281.897L992.37 218.516L1147.8 308.155Z",
    fill: "#15C5F3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.58 245.078V306.044L993.578 402.626V341.659L1159.58 245.078Z",
    fill: "url(#paint27_linear_1419_1910)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M993.586 341.656V402.623L780.806 280.086V218.817L993.586 341.656Z",
    fill: "url(#paint28_linear_1419_1910)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M788.06 275.558L789.267 233.605L985.145 346.485L983.938 388.437L788.06 275.558Z",
    fill: "url(#paint29_linear_1419_1910)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.58 245.077L993.586 341.658L780.806 218.819L946.804 122.54L1159.58 245.077Z",
    fill: "url(#paint30_linear_1419_1910)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M999.034 345.578L1155.98 255.033V302.72L999.034 393.265V345.578Z",
    fill: "#D9E1EE"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.58 346.786L1069.68 308.757V349.502L1003.58 387.531V346.786Z",
    fill: "#96AAC9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.72 346.484L1006.91 356.746V377.571L1024.72 367.31V346.484Z",
    fill: "#0C65F5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.82 334.415L1028.01 344.676V365.502L1045.82 355.24V334.415Z",
    fill: "#0C65F5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.37 322.639L1048.26 332.901V353.726L1066.37 343.465V322.639Z",
    fill: "#0C65F5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.5 319.318L1126.43 317.205V275.554L1122.5 277.969V319.318Z",
    fill: "#96AAC9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.04 324.144L1118.27 321.73V280.381L1114.04 282.795V324.144Z",
    fill: "#96AAC9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.88 328.978L1110.1 326.564V285.215L1105.88 287.629V328.978Z",
    fill: "#96AAC9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.74 333.805L1101.67 331.39V290.041L1097.74 292.154V333.805Z",
    fill: "#96AAC9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.29 338.63L1093.51 336.216V294.565L1089.29 296.98V338.63Z",
    fill: "#96AAC9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.15 343.464L1085.07 341.05V299.399L1081.15 301.814V343.464Z",
    fill: "#96AAC9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.69 347.989L1076.92 345.876V304.226L1072.69 306.64V347.989Z",
    fill: "#96AAC9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.81 188.334V244.773L993.578 334.413V277.973L1147.81 188.334Z",
    fill: "url(#paint31_linear_1419_1910)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M993.577 277.97V334.41L792.567 218.512V162.073L993.577 277.97Z",
    fill: "#0EB5E3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.8 188.331L993.577 277.971L792.567 162.073L946.795 72.4341L1147.8 188.331Z",
    fill: "#15C5F3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.58 122.54V183.808L993.578 280.087V219.121L1159.58 122.54Z",
    fill: "url(#paint32_linear_1419_1910)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M993.586 219.118V280.085L780.806 157.548V96.5808L993.586 219.118Z",
    fill: "url(#paint33_linear_1419_1910)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M788.06 153.322L789.267 111.37L985.145 223.947L983.938 266.201L788.06 153.322Z",
    fill: "url(#paint34_linear_1419_1910)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.58 122.537L993.586 219.118L780.806 96.5812L946.804 0L1159.58 122.537Z",
    fill: "url(#paint35_linear_1419_1910)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M999.034 223.341L1155.98 132.495V180.182L999.034 271.028V223.341Z",
    fill: "#D9E1EE"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.58 224.55L1069.68 186.22V226.965L1003.58 265.296V224.55Z",
    fill: "#96AAC9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.72 224.249L1006.91 234.511V255.336L1024.72 245.074V224.249Z",
    fill: "#0C65F5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.82 212.179L1028.01 222.441V243.267L1045.82 233.005V212.179Z",
    fill: "#0C65F5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.37 200.102L1048.26 210.364V231.189L1066.37 220.927V200.102Z",
    fill: "#0C65F5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.5 197.081L1126.43 194.666V153.318L1122.5 155.43V197.081Z",
    fill: "#96AAC9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.04 201.907L1118.27 199.493V157.842L1114.04 160.257V201.907Z",
    fill: "#96AAC9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.88 206.741L1110.1 204.327V162.676L1105.88 165.091V206.741Z",
    fill: "#96AAC9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.74 211.265L1101.67 209.152V167.502L1097.74 169.916V211.265Z",
    fill: "#96AAC9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.29 216.092L1093.51 213.677V172.328L1089.29 174.743V216.092Z",
    fill: "#96AAC9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.15 220.926L1085.07 218.511V177.162L1081.15 179.577V220.926Z",
    fill: "#96AAC9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.69 225.752L1076.92 223.338V181.989L1072.69 184.102V225.752Z",
    fill: "#96AAC9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.072 271.633L797.105 355.236C791.371 358.556 784.127 358.556 778.393 355.236L583.42 242.961C571.045 235.717 571.045 217.608 583.42 210.365L727.386 126.762C733.12 123.442 740.364 123.442 746.098 126.762L941.072 239.037C953.446 246.281 953.446 264.39 941.072 271.633Z",
    fill: "white"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M956.183 605.151L957.089 666.42L792.599 765.415L791.693 704.147L956.183 605.151Z",
    fill: "url(#paint36_linear_1419_1910)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M791.677 704.142L792.583 765.41L577.991 645.891L577.086 584.623L791.677 704.142Z",
    fill: "url(#paint37_linear_1419_1910)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M585.221 641.363L585.824 599.411L783.212 709.272L782.608 751.225L585.221 641.363Z",
    fill: "url(#paint38_linear_1419_1910)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M956.167 605.148L791.677 704.143L577.086 584.624L787.754 511.283L956.167 605.148Z",
    fill: "url(#paint39_linear_1419_1910)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M797.112 708.065L952.849 615.106L953.755 663.095L798.018 756.054L797.112 708.065Z",
    fill: "#D9E1EE"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M801.65 709.275L867.144 670.039L867.748 710.784L802.254 750.02L801.65 709.275Z",
    fill: "#96AAC9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M823.084 708.672L805.277 719.236L805.579 740.061L823.386 729.498L823.084 708.672Z",
    fill: "#0C65F5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M843.892 696.301L826.085 706.864L826.387 727.689L844.194 717.126L843.892 696.301Z",
    fill: "#0C65F5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M864.142 684.223L846.335 694.787L846.637 715.612L864.444 705.049L864.142 684.223Z",
    fill: "#19F7FB"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M920.237 680.297L924.161 677.883L923.557 636.232L919.634 638.647L920.237 680.297Z",
    fill: "#96AAC9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M912.102 685.124L916.025 682.709L915.422 641.059L911.498 643.473L912.102 685.124Z",
    fill: "#96AAC9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M903.644 689.958L907.869 687.544L907.265 646.195L903.04 648.609L903.644 689.958Z",
    fill: "#96AAC9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M895.479 694.785L899.704 692.37L899.1 651.021L894.875 653.436L895.479 694.785Z",
    fill: "#96AAC9"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M887.344 699.912L891.268 697.498L890.664 655.847L886.74 658.262L887.344 699.912Z",
    fill: "#96AAC9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M879.179 704.746L883.102 702.332L882.499 660.681L878.575 663.096L879.179 704.746Z",
    fill: "#96AAC9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M871.044 709.573L874.968 707.158L874.364 665.81L870.44 668.224L871.044 709.573Z",
    fill: "#96AAC9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M943.495 548.405L944.401 604.844L791.38 696.898L790.776 640.459L943.495 548.405Z",
    fill: "url(#paint40_linear_1419_1910)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M790.788 640.46L791.392 696.9L588.873 584.021L587.968 527.581L790.788 640.46Z",
    fill: "url(#paint41_linear_1419_1910)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M943.507 548.408L790.788 640.462L587.968 527.583L786.865 461.183L943.507 548.408Z",
    fill: "#15C5F3"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M954.385 482.612L955.291 543.579L790.801 642.575L789.896 581.608L954.385 482.612Z",
    fill: "url(#paint42_linear_1419_1910)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M789.88 581.602L790.786 642.568L576.195 523.049L575.289 462.082L789.88 581.602Z",
    fill: "url(#paint43_linear_1419_1910)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M583.424 518.823L584.027 476.569L781.415 586.43L780.812 628.684L583.424 518.823Z",
    fill: "url(#paint44_linear_1419_1910)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M954.37 482.608L789.88 581.604L575.289 462.085L785.957 388.743L954.37 482.608Z",
    fill: "url(#paint45_linear_1419_1910)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M795.314 585.526L951.052 492.566L951.655 540.253L796.22 633.213L795.314 585.526Z",
    fill: "#D9E1EE"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M799.853 586.735L865.347 547.499L865.95 588.244L800.456 627.48L799.853 586.735Z",
    fill: "#96AAC9"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M821.287 586.132L803.479 596.695L803.781 617.521L821.588 606.957L821.287 586.132Z",
    fill: "#0C65F5"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M842.094 573.76L824.287 584.324L824.589 605.149L842.396 594.585L842.094 573.76Z",
    fill: "#0C65F5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M862.344 561.381L844.537 571.944L844.839 592.77L862.646 582.206L862.344 561.381Z",
    fill: "#0C65F5"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M918.445 557.455L922.369 555.041L921.765 513.692L917.842 516.107L918.445 557.455Z",
    fill: "#96AAC9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M910.288 562.282L914.212 559.867L913.608 518.519L909.383 520.933L910.288 562.282Z",
    fill: "#96AAC9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M901.852 567.418L906.077 565.003L905.473 523.353L901.248 525.767L901.852 567.418Z",
    fill: "#96AAC9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M893.687 572.243L897.912 569.829L897.308 528.178L893.083 530.593L893.687 572.243Z",
    fill: "#96AAC9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M885.552 577.07L889.475 574.656L888.872 533.307L884.948 535.721L885.552 577.07Z",
    fill: "#96AAC9"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M877.387 581.904L881.31 579.49L880.707 538.141L876.783 540.555L877.387 581.904Z",
    fill: "#96AAC9"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M869.252 587.033L873.176 584.618L872.572 542.967L868.648 545.382L869.252 587.033Z",
    fill: "#96AAC9"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M941.711 424.355L942.617 480.795L789.596 572.849L788.69 516.107L941.711 424.355Z",
    fill: "url(#paint46_linear_1419_1910)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M788.693 516.108L789.599 572.85L587.08 459.97L586.175 403.531L788.693 516.108Z",
    fill: "url(#paint47_linear_1419_1910)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M941.714 424.358L788.693 516.11L586.175 403.532L785.072 337.133L941.714 424.358Z",
    fill: "#15C5F3"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M952.556 360.981L953.462 422.25L788.972 521.245L788.066 459.977L952.556 360.981Z",
    fill: "url(#paint48_linear_1419_1910)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M788.064 459.979L788.969 521.247L574.378 401.728L573.473 340.459L788.064 459.979Z",
    fill: "url(#paint49_linear_1419_1910)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M581.607 397.2L582.211 355.248L779.599 465.109L778.995 507.061L581.607 397.2Z",
    fill: "url(#paint50_linear_1419_1910)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M952.554 360.983L788.064 459.978L573.473 340.459L737.962 241.765L952.554 360.983Z",
    fill: "url(#paint51_linear_1419_1910)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M793.492 463.903L949.229 370.943L950.135 418.932L794.398 511.892L793.492 463.903Z",
    fill: "#D9E1EE"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M798.03 465.112L863.524 425.876L864.128 466.621L798.634 505.857L798.03 465.112Z",
    fill: "#96AAC9"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M819.464 464.509L801.657 475.072L801.959 495.898L819.766 485.334L819.464 464.509Z",
    fill: "#0C65F5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M840.272 452.137L822.465 462.701L822.767 483.526L840.574 472.963L840.272 452.137Z",
    fill: "#0C65F5"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M860.522 440.06L842.715 450.624L843.017 471.449L860.824 460.885L860.522 440.06Z",
    fill: "#0C65F5"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M916.616 436.134L920.54 433.72L919.936 392.069L916.013 394.483L916.616 436.134Z",
    fill: "#96AAC9"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M908.481 440.961L912.404 438.546L911.801 396.896L907.877 399.31L908.481 440.961Z",
    fill: "#96AAC9"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M900.023 445.795L904.248 443.38L903.644 402.031L899.419 404.446L900.023 445.795Z",
    fill: "#96AAC9"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M891.857 450.621L896.083 448.207L895.479 406.858L891.254 409.273L891.857 450.621Z",
    fill: "#96AAC9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M883.723 455.749L887.646 453.334L887.043 411.684L883.119 414.098L883.723 455.749Z",
    fill: "#96AAC9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M875.558 460.583L879.481 458.168L878.878 416.518L874.954 418.932L875.558 460.583Z",
    fill: "#96AAC9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M867.423 465.41L871.347 462.995L870.743 421.646L866.819 424.061L867.423 465.41Z",
    fill: "#96AAC9"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M939.862 304.536L940.768 360.975L787.747 453.029L787.144 396.59L939.862 304.536Z",
    fill: "url(#paint52_linear_1419_1910)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M787.149 396.591L787.753 453.031L585.235 340.152L584.329 283.712L787.149 396.591Z",
    fill: "url(#paint53_linear_1419_1910)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M939.868 304.536L787.149 396.59L584.329 283.711L737.35 191.657L939.868 304.536Z",
    fill: "#15C5F3"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M950.765 238.743L951.671 299.71L787.181 398.706L786.275 337.739L950.765 238.743Z",
    fill: "url(#paint54_linear_1419_1910)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M786.267 337.74L787.172 398.707L572.581 279.188L571.676 218.221L786.267 337.74Z",
    fill: "url(#paint55_linear_1419_1910)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M579.811 274.962L580.414 232.707L777.802 342.568L777.198 384.823L579.811 274.962Z",
    fill: "url(#paint56_linear_1419_1910)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M950.757 238.744L786.267 337.74L571.676 218.221L736.165 119.225L950.757 238.744Z",
    fill: "url(#paint57_linear_1419_1910)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M791.695 341.664L947.432 248.704L948.338 296.391L792.601 389.351L791.695 341.664Z",
    fill: "#D9E1EE"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M796.227 342.873L861.721 303.636L862.324 344.382L796.83 383.618L796.227 342.873Z",
    fill: "#96AAC9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M817.661 342.27L799.854 352.833L800.155 373.658L817.962 363.095L817.661 342.27Z",
    fill: "#0C65F5"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M838.468 329.898L820.661 340.461L820.963 361.287L838.77 350.723L838.468 329.898Z",
    fill: "#0C65F5"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M858.719 317.519L840.912 328.082L841.214 348.908L859.021 338.344L858.719 317.519Z",
    fill: "#0C65F5"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M914.819 313.593L918.743 311.179L918.139 269.83L914.216 272.244L914.819 313.593Z",
    fill: "#96AAC9"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M906.685 318.42L910.608 316.005L910.005 274.656L906.081 277.071L906.685 318.42Z",
    fill: "#96AAC9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M898.226 323.555L902.451 321.14L901.847 279.49L897.622 281.904L898.226 323.555Z",
    fill: "#96AAC9"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M890.061 328.381L894.286 325.967L893.682 284.316L889.457 286.731L890.061 328.381Z",
    fill: "#96AAC9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M881.926 333.208L885.849 330.793L885.246 289.445L881.322 291.859L881.926 333.208Z",
    fill: "#96AAC9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M873.761 338.042L877.684 335.628L877.081 294.279L873.157 296.693L873.761 338.042Z",
    fill: "#96AAC9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M865.626 343.17L869.55 340.756L868.946 299.105L865.022 301.52L865.626 343.17Z",
    fill: "#96AAC9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M728.916 405.35L584.95 488.952C579.215 492.272 571.972 492.272 566.237 488.952L371.264 376.677C358.89 369.433 358.89 351.324 371.264 344.081L515.23 260.478C520.965 257.158 528.209 257.158 533.943 260.478L728.916 372.753C741.291 380.299 741.291 398.106 728.916 405.35Z",
    fill: "white"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M739.459 739.449V800.717L573.46 896.997V836.03L739.459 739.449Z",
    fill: "url(#paint58_linear_1419_1910)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M573.463 836.034V897L360.683 774.463V713.194L573.463 836.034Z",
    fill: "url(#paint59_linear_1419_1910)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M367.931 770.237L369.138 727.983L565.017 840.862L563.809 882.814L367.931 770.237Z",
    fill: "url(#paint60_linear_1419_1910)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M739.462 739.451L573.463 836.032L360.683 713.193L572.256 643.172L739.462 739.451Z",
    fill: "url(#paint61_linear_1419_1910)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M578.909 839.956L736.155 749.411V797.098L578.909 887.643V839.956Z",
    fill: "#D9E1EE"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M583.447 841.164L649.545 803.135V843.88L583.447 881.909V841.164Z",
    fill: "#96AAC9"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M604.889 840.862L586.78 851.124V872.251L604.889 861.687V840.862Z",
    fill: "#027DF7"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M625.689 828.792L607.882 839.054V860.181L625.689 849.617V828.792Z",
    fill: "#027DF7"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M646.241 817.017L628.132 827.279V848.104L646.241 837.842V817.017Z",
    fill: "#027DF7"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M702.372 813.998L706.296 811.583V769.933L702.372 772.347V813.998Z",
    fill: "#96AAC9"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M693.913 818.523L698.138 816.41V774.759L694.215 777.174L693.913 818.523Z",
    fill: "#96AAC9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M685.748 823.356L689.974 820.941V779.592L685.748 782.007V823.356Z",
    fill: "#96AAC9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M677.613 828.182L681.537 825.768V784.419L677.613 786.833V828.182Z",
    fill: "#96AAC9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M669.155 833.009L673.381 830.594V789.245L669.155 791.358V833.009Z",
    fill: "#96AAC9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M661.021 837.843L664.944 835.428V793.777L661.021 796.192V837.843Z",
    fill: "#96AAC9"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M652.562 842.668L656.787 840.254V798.603L652.562 801.018V842.668Z",
    fill: "#96AAC9"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M727.682 682.408V738.848L573.454 828.487V772.048L727.682 682.408Z",
    fill: "url(#paint62_linear_1419_1910)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M573.448 772.052V828.491L372.438 712.896V656.154L573.448 772.052Z",
    fill: "url(#paint63_linear_1419_1910)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M727.676 682.409L573.448 772.048L372.438 656.151L572.241 592.77L727.676 682.409Z",
    fill: "#15C5F3"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M739.459 616.911V677.877L573.46 774.458V713.19L739.459 616.911Z",
    fill: "url(#paint64_linear_1419_1910)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M573.463 713.194V774.462L360.683 651.623V590.656L573.463 713.194Z",
    fill: "url(#paint65_linear_1419_1910)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M367.931 647.397L369.138 605.445L565.017 718.022L563.809 760.276L367.931 647.397Z",
    fill: "url(#paint66_linear_1419_1910)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M739.462 616.912L573.463 713.192L360.683 590.654L572.256 520.331L739.462 616.912Z",
    fill: "url(#paint67_linear_1419_1910)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M578.909 717.417L736.155 626.571V674.56L578.909 765.104V717.417Z",
    fill: "#D9E1EE"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M583.447 718.627L649.545 680.296V721.041L583.447 759.372V718.627Z",
    fill: "#96AAC9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M604.889 718.324L586.78 728.586V749.411L604.889 739.15V718.324Z",
    fill: "#027DF7"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M625.689 706.256L607.882 716.517V737.343L625.689 727.081V706.256Z",
    fill: "#027DF7"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M646.241 694.178L628.132 704.44V725.567L646.241 715.004V694.178Z",
    fill: "#027DF7"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M702.372 691.159L706.296 688.744V647.395L702.372 649.508V691.159Z",
    fill: "#96AAC9"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M693.913 695.985L698.138 693.57V651.92L694.215 654.334L693.913 695.985Z",
    fill: "#96AAC9"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M685.748 700.818L689.974 698.404V656.753L685.748 659.168V700.818Z",
    fill: "#96AAC9"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M677.613 705.343L681.537 703.23V661.58L677.613 663.994V705.343Z",
    fill: "#96AAC9"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M669.155 710.169L673.381 707.755V666.406L669.155 668.821V710.169Z",
    fill: "#96AAC9"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M661.021 715.004L664.944 712.589V671.24L661.021 673.655V715.004Z",
    fill: "#96AAC9"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M652.562 719.829L656.787 717.415V676.066L652.562 678.179V719.829Z",
    fill: "#96AAC9"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M727.682 558.359V614.798L573.454 704.438V647.998L727.682 558.359Z",
    fill: "url(#paint68_linear_1419_1910)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M573.448 648.002V704.442L372.438 588.544V532.105L573.448 648.002Z",
    fill: "url(#paint69_linear_1419_1910)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M727.676 558.359L573.448 647.999L372.438 532.101L572.241 468.72L727.676 558.359Z",
    fill: "#15C5F3"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M739.459 495.286V556.253L573.46 652.834V591.565L739.459 495.286Z",
    fill: "url(#paint70_linear_1419_1910)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M573.463 591.561V652.83L360.683 530.292V469.024L573.463 591.561Z",
    fill: "url(#paint71_linear_1419_1910)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M367.931 525.765L369.138 483.813L565.017 596.692L563.809 638.644L367.931 525.765Z",
    fill: "url(#paint72_linear_1419_1910)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M739.462 495.284L573.463 591.563L360.683 469.025L526.681 372.746L739.462 495.284Z",
    fill: "url(#paint73_linear_1419_1910)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M578.909 595.785L736.155 505.24V552.927L578.909 643.472V595.785Z",
    fill: "#D9E1EE"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M583.447 596.992L649.545 558.964V599.709L583.447 637.738V596.992Z",
    fill: "#96AAC9"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M604.889 596.691L586.78 606.953V627.778L604.889 617.516V596.691Z",
    fill: "#027DF7"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M625.689 584.621L607.882 594.883V615.708L625.689 605.447V584.621Z",
    fill: "#027DF7"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M646.241 572.846L628.132 583.108V603.933L646.241 593.671V572.846Z",
    fill: "#027DF7"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M702.372 569.525L706.296 567.412V525.762L702.372 528.176V569.525Z",
    fill: "#96AAC9"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M693.913 574.352L698.138 571.937V530.588L694.215 533.003L693.913 574.352Z",
    fill: "#96AAC9"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M685.748 579.185L689.974 576.77V535.422L685.748 537.836V579.185Z",
    fill: "#96AAC9"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M677.613 584.011L681.537 581.597V540.248L677.613 542.361V584.011Z",
    fill: "#96AAC9"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M669.155 588.838L673.381 586.423V544.773L669.155 547.187V588.838Z",
    fill: "#96AAC9"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M661.021 593.672L664.944 591.257V549.607L661.021 552.021V593.672Z",
    fill: "#96AAC9"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M652.562 598.196L656.787 596.083V554.432L652.562 556.847V598.196Z",
    fill: "#96AAC9"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M727.682 438.539V494.978L573.454 584.618V528.178L727.682 438.539Z",
    fill: "url(#paint74_linear_1419_1910)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M573.448 528.175V584.614L372.438 468.717V412.277L573.448 528.175Z",
    fill: "url(#paint75_linear_1419_1910)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M727.676 438.536L573.448 528.175L372.438 412.278L526.666 322.638L727.676 438.536Z",
    fill: "#15C5F3"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M739.459 372.746V434.015L573.46 530.294V469.327L739.459 372.746Z",
    fill: "url(#paint76_linear_1419_1910)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M573.463 469.324V530.291L360.683 407.754V346.787L573.463 469.324Z",
    fill: "url(#paint77_linear_1419_1910)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M367.931 403.527L369.138 361.575L565.017 474.152L563.809 516.407L367.931 403.527Z",
    fill: "url(#paint78_linear_1419_1910)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M739.462 372.745L573.463 469.326L360.683 346.789L526.681 250.207L739.462 372.745Z",
    fill: "url(#paint79_linear_1419_1910)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M578.909 473.548L736.155 382.701V430.388L578.909 521.235V473.548Z",
    fill: "#D9E1EE"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M583.447 474.757L649.545 436.426V477.172L583.447 515.502V474.757Z",
    fill: "#96AAC9"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M604.889 474.153L586.78 484.716V505.542L604.889 495.28V474.153Z",
    fill: "#027DF7"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M625.689 462.386L607.882 472.648V493.473L625.689 483.211V462.386Z",
    fill: "#027DF7"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M646.241 450.309L628.132 460.57V481.396L646.241 471.134V450.309Z",
    fill: "#027DF7"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M702.372 447.289L706.296 444.874V403.224L702.372 405.638V447.289Z",
    fill: "#96AAC9"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M693.913 452.115L698.138 449.701V408.05L694.215 410.465L693.913 452.115Z",
    fill: "#96AAC9"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M685.748 456.949L689.974 454.535V412.884L685.748 415.299V456.949Z",
    fill: "#96AAC9"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M677.613 461.473L681.537 459.361V417.71L677.613 420.124V461.473Z",
    fill: "#96AAC9"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M669.155 466.3L673.381 463.885V422.536L669.155 424.951V466.3Z",
    fill: "#96AAC9"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M661.021 471.134L664.944 468.719V427.37L661.021 429.785V471.134Z",
    fill: "#96AAC9"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M652.562 475.96L656.787 473.546V432.197L652.562 434.31V475.96Z",
    fill: "#96AAC9"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M479.891 514.909C479.891 507.665 479.287 500.421 478.683 492.876H500.414C498.905 497.705 497.396 502.232 496.189 506.458C494.981 517.625 503.13 520.643 497.698 532.112C496.792 534.225 493.472 536.338 492.265 536.639C487.436 538.148 485.625 541.468 484.116 544.487C483.211 546.599 482.003 548.41 480.192 549.919C473.552 555.352 458.764 554.447 455.745 549.316C451.52 542.072 472.345 528.189 478.985 515.512C479.287 515.512 479.589 515.21 479.891 514.909Z",
    fill: "#1B1823"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M417.432 462.086C415.923 461.181 413.206 459.672 411.094 457.861C409.585 460.577 408.076 462.992 406.566 465.708C406.265 466.01 405.963 466.01 405.661 466.312C392.683 473.857 365.821 475.064 365.821 483.817C365.821 490.155 378.799 499.21 387.552 497.7C389.967 497.399 392.079 496.191 394.192 494.682C397.21 492.871 400.53 490.759 405.661 491.966C406.868 492.268 410.792 492.268 412.905 490.759C424.072 483.817 418.941 476.573 425.279 467.519C422.865 465.708 420.148 463.595 417.432 462.086Z",
    fill: "#1B1823"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M477.479 429.495C477.479 429.495 477.781 409.274 488.948 389.354C497.701 373.659 517.923 357.06 518.526 357.06C518.828 357.06 563.799 374.565 561.384 379.394C559.875 382.11 512.792 426.477 511.886 428.59C510.075 432.212 509.774 434.324 510.377 438.55C513.395 454.848 505.548 501.629 501.625 516.117C495.286 517.928 479.29 517.626 473.254 514.306C473.556 513.702 476.876 440.361 477.479 429.495C477.479 429.495 476.876 440.361 477.479 429.495Z",
    fill: "url(#paint80_linear_1419_1910)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M477.483 430.096C477.483 429.795 477.483 429.493 477.483 429.493C477.181 438.547 477.483 432.511 477.483 430.096Z",
    fill: "#123F5D"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M543.891 420.74C514.012 417.722 487.754 412.29 487.754 412.29C476.586 445.791 427.692 474.162 421.656 478.085C418.336 477.482 405.961 467.824 403.547 463.598C413.205 448.809 459.081 387.239 473.266 378.184C482.019 372.45 560.189 376.977 560.491 373.053C560.491 371.544 578.6 370.035 580.109 370.035C595.2 370.639 596.709 426.173 543.891 420.74Z",
    fill: "url(#paint81_linear_1419_1910)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M542.077 211.883C542.379 218.523 545.397 225.465 542.983 231.501C541.473 235.123 538.154 237.537 536.041 240.556C532.419 245.385 531.514 252.025 533.023 257.759C534.23 261.683 536.644 265.003 537.55 268.926C539.059 274.963 537.55 280.999 535.437 286.733C533.324 292.468 530.608 298.202 530.306 304.239C530.004 306.955 530.608 309.973 532.721 311.482C534.834 312.991 537.55 312.086 539.964 311.181C545.397 308.766 549.924 304.541 552.641 299.41C557.47 290.053 556.564 279.188 557.47 268.625C558.073 261.079 559.884 253.836 561.092 246.29C561.997 238.745 562.299 231.199 560.186 223.956C558.073 217.618 554.15 211.581 553.848 204.941C553.848 201.923 554.753 199.207 555.357 196.189C555.659 194.378 555.055 193.472 553.244 193.472C548.717 193.17 545.397 199.509 543.888 203.13C542.681 205.847 542.077 208.865 542.077 211.883Z",
    fill: "#260905"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M526.09 288.845C528.505 293.674 536.956 297.296 541.785 298.805L520.959 323.554C515.828 320.234 505.868 316.31 504.359 308.765C507.981 302.125 517.036 290.656 523.676 281.299C524.279 284.317 525.185 287.034 526.09 288.845Z",
    fill: "#FFC6A6"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M528.201 297.898C523.372 295.484 520.957 290.956 519.448 286.429C528.201 270.131 537.859 254.437 537.859 254.437C540.575 249.306 551.139 246.891 556.27 249.608C556.27 249.608 558.684 258.964 555.968 264.095L537.859 300.011C534.539 299.105 530.615 299.105 528.201 297.898Z",
    fill: "#0894F7"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M592.497 264.998C592.195 268.318 590.384 271.337 587.969 273.147C585.555 274.958 582.235 276.166 578.915 275.562L547.828 286.126C544.206 285.824 546.319 269.828 544.206 267.111C545.112 266.206 545.715 265.3 546.017 263.791C546.319 260.773 547.526 258.66 549.337 255.944C550.544 254.133 554.468 250.209 555.373 249.304L559.297 248.399L561.108 248.7L578.915 250.511C579.217 250.813 579.519 250.813 579.519 251.115C590.686 259.868 585.253 254.133 592.497 264.998Z",
    fill: "#FFC6A6"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M580.101 245.079L579.497 249.002L579.196 250.813L578.29 256.85C578.29 256.85 577.385 258.057 575.876 259.264C575.574 259.566 575.272 259.868 574.668 260.17C573.461 260.773 572.254 261.377 570.745 261.679C569.236 261.981 567.425 262.282 565.614 261.981C565.01 261.981 564.407 261.981 563.501 261.679C562.897 261.679 561.992 261.377 561.388 261.075C559.879 260.471 558.974 259.566 558.672 258.661C558.672 258.359 558.37 258.359 558.37 258.057C558.068 257.151 557.767 256.246 557.767 255.341L558.974 248.399L559.578 245.682L560.483 240.853L562.294 241.155L580.101 245.079Z",
    fill: "#FFC6A6"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M531.213 323.251C530.006 338.945 524.573 346.792 518.537 362.789C520.046 363.694 521.555 365.203 523.064 366.109C527.29 369.127 530.912 370.334 536.042 371.239C539.362 371.843 543.89 372.145 546.304 374.559C547.813 376.068 548.115 378.785 549.624 380.294C551.435 382.407 554.755 383.614 557.17 384.519C571.355 388.745 587.049 394.177 595.5 382.105C600.933 374.559 593.689 374.559 592.784 365.505C591.275 350.716 592.784 341.058 594.595 327.476C596.104 316.309 599.424 307.254 602.442 296.087C603.951 291.258 614.213 285.222 613.609 280.091C612.704 269.829 590.369 259.266 582.522 254.437C579.806 266.207 572.562 281.902 558.075 281.298C535.741 280.393 549.624 257.757 557.773 248.702C545.399 247.495 539.966 257.757 533.93 269.829C531.515 274.658 526.082 280.996 524.875 285.222C520.65 300.614 532.421 305.745 531.213 323.251Z",
    fill: "url(#paint82_linear_1419_1910)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M586.451 304.239C584.64 318.123 583.433 332.911 582.528 342.871C581.924 342.871 581.019 343.173 580.415 343.173C571.059 344.381 561.099 347.399 555.666 348.606C546.612 350.417 533.03 356.755 533.03 356.755C531.823 357.057 530.615 357.057 529.408 356.755C527.899 356.755 526.39 355.85 526.39 355.85C525.786 355.246 523.674 353.737 523.372 353.435C520.655 351.926 517.637 351.322 514.921 349.813C514.015 349.511 511.903 347.7 510.696 347.7C510.394 347.7 510.394 348.002 510.394 348.304C509.488 351.322 512.506 352.53 514.619 353.435C513.412 353.133 512.205 352.831 510.997 352.831C509.488 352.53 502.546 351.02 502.245 352.831C502.245 353.737 503.452 354.039 504.056 354.34C506.772 355.246 509.488 356.151 512.506 356.755C510.092 356.453 507.677 355.85 505.263 355.548C504.056 355.246 499.83 354.944 499.528 356.453C499.528 357.057 499.83 357.359 500.434 357.66C502.547 358.264 504.961 358.868 507.376 359.17C505.866 359.17 504.357 358.868 502.848 358.868C502.245 358.868 500.736 358.868 500.434 359.773C499.83 360.98 501.339 361.282 501.943 361.584C504.961 362.188 507.677 362.791 510.696 363.093C508.885 363.395 504.357 363.093 502.848 363.697C502.546 363.697 502.245 363.999 502.546 364.3C502.848 364.904 503.452 364.904 504.056 365.206C507.677 366.111 509.488 366.715 513.11 367.62C514.619 367.922 517.034 368.224 518.543 368.526C520.354 368.526 521.863 368.828 523.674 369.129C524.881 369.129 526.692 369.431 528.201 369.431L529.408 369.129C548.423 368.526 564.419 367.922 583.433 367.319C589.47 367.017 596.713 367.017 600.939 363.093C600.939 363.093 600.939 363.093 600.939 362.791C602.146 361.584 603.353 359.773 603.655 357.359C606.975 348.606 610.295 323.555 611.804 308.163L586.451 304.239Z",
    fill: "#FFD6BF"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M592.775 321.438C589.153 319.929 586.739 318.118 584.324 315.704C585.833 302.424 587.644 287.937 590.662 277.071C592.473 269.828 600.019 266.206 606.357 268.621C610.884 270.431 614.808 276.166 614.808 282.806C614.808 284.013 614.808 286.428 614.506 289.748C614.506 289.748 612.997 305.14 610.884 321.438C604.848 323.249 598.811 323.853 592.775 321.438Z",
    fill: "url(#paint83_linear_1419_1910)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M580.703 244.478L580.1 248.1L579.194 255.042C579.194 255.042 578.289 256.249 576.78 257.154C576.478 257.456 576.176 257.758 575.573 257.758C574.365 258.362 573.158 258.965 571.649 259.267C569.234 259.569 567.122 259.871 564.707 259.267C564.103 259.267 563.198 258.965 562.594 258.663C561.085 258.06 560.18 257.154 559.576 255.947C559.274 255.042 558.973 254.438 558.973 253.533L560.482 244.78L561.387 240.554L580.703 244.478Z",
    fill: "#FFC6A6"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M592.779 231.802C579.499 242.063 575.273 251.118 564.106 242.063C553.241 232.707 546.299 212.184 551.128 196.187C556.259 179.286 578.895 178.984 592.175 188.944C609.379 201.318 605.757 222.144 592.779 231.802Z",
    fill: "#260905"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M549.316 207.656C547.505 223.35 546.902 239.648 555.051 246.892C557.767 249.306 561.389 249.608 565.312 249.306C566.218 249.306 566.822 249.005 567.727 249.005C572.254 248.099 576.48 246.288 579.196 244.779C583.12 242.666 588.251 228.481 589.76 223.652C593.985 208.259 582.516 206.449 573.16 198.601C563.803 190.452 551.429 191.961 549.316 207.656Z",
    fill: "#FFD6BF"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M589.451 224.257C587.64 228.181 585.226 230.293 582.51 229.69C579.793 229.086 578.888 226.068 580.095 221.843C581.302 217.617 585.226 214.901 587.942 215.505C590.357 216.108 591.564 219.73 589.451 224.257Z",
    fill: "#FFD6BF"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M567.116 208.867C561.683 207.056 554.138 205.547 551.421 200.114C550.818 198.907 550.516 197.7 550.214 196.492C552.93 190.154 555.647 190.456 565.305 186.231C571.945 183.514 577.377 180.798 581.301 188.947C581.905 190.456 584.017 191.362 582.81 191.362C574.963 203.736 593.072 217.62 580.697 221.543C580.094 215.205 572.246 210.678 567.116 208.867Z",
    fill: "#260905"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M584.637 229.083C582.223 232.403 579.808 233.912 577.394 233.007C575.281 232.102 574.677 229.083 576.488 225.462C578.299 221.84 582.525 220.029 584.637 220.934C587.052 222.142 587.354 225.462 584.637 229.083Z",
    fill: "#FFD6BF"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M591.272 188.339C593.989 190.452 596.403 192.565 598.214 194.979C599.723 198.601 602.44 201.921 603.647 205.844C604.854 210.07 604.251 214.295 603.647 218.521C603.043 223.652 602.138 229.688 598.818 233.913L575.88 231.197C577.389 218.521 577.389 206.75 574.069 198.299C570.447 190.15 581.916 180.794 591.272 188.339Z",
    fill: "#260905"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M565.617 325.366C561.391 321.141 556.562 317.821 557.166 310.879C557.467 306.653 559.58 303.032 561.995 299.712C563.806 298.504 565.315 297.297 565.918 295.184C566.22 294.279 566.22 293.374 566.522 292.468C566.522 290.355 566.824 288.545 565.918 286.734C565.013 284.621 563.806 283.112 563.806 280.697C563.806 277.981 565.918 275.868 568.333 274.359C570.446 272.85 573.162 271.945 575.275 270.134C575.878 269.832 576.18 269.228 576.18 268.625C576.18 267.719 575.878 267.116 575.275 266.512C573.766 264.701 571.653 263.192 570.747 261.079C569.54 258.665 569.842 255.647 570.747 252.93C571.955 250.516 573.766 248.403 575.878 246.592C577.387 245.083 579.5 243.574 579.198 241.461C578.896 239.349 576.482 238.141 574.973 236.632C572.558 234.218 572.256 230.596 572.558 227.276C573.464 217.014 579.802 207.356 588.856 202.225C592.176 200.414 596.402 199.207 599.42 201.018L599.722 196.189C606.06 204.036 606.362 214.901 605.456 224.861C605.154 228.785 604.551 232.709 602.438 236.029C600.627 239.047 597.911 241.461 597.005 244.781C595.798 248.101 596.704 252.025 597.911 255.345C598.816 257.759 600.024 260.777 599.118 263.192C598.213 265.607 596.1 267.116 593.685 268.021C591.271 268.926 588.856 269.53 586.744 271.039C581.915 274.359 581.613 281.301 583.122 287.035C584.329 290.959 586.14 295.486 583.424 298.806C582.518 300.014 581.009 300.617 579.802 301.523C575.576 304.239 573.162 309.672 574.369 314.501C575.275 318.424 578.595 322.046 577.689 325.97C577.086 328.686 574.973 330.799 573.162 332.911C572.558 333.515 571.955 334.421 571.351 335.024C569.54 331.704 568.031 328.082 565.617 325.366Z",
    fill: "#260905"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M517.618 311.479C512.789 304.235 515.204 302.424 507.96 307.253L457.255 319.93C456.953 323.25 456.953 326.871 456.953 330.191C456.953 331.7 456.953 333.21 456.953 334.719C456.953 334.719 511.28 337.133 520.938 324.155C524.56 319.326 522.447 318.722 517.618 311.479Z",
    fill: "#FFC6A6"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M523.351 340.759L457.857 302.126C456.951 301.523 456.046 301.523 455.442 301.824C454.235 302.428 453.329 303.032 452.122 303.635C452.726 303.333 453.631 303.333 454.537 303.937L457.857 306.05H457.555C456.951 306.352 456.348 306.653 455.744 307.257C455.442 307.559 454.838 307.861 454.537 307.861C454.235 308.162 453.933 308.464 453.933 309.068L453.329 349.209C453.329 350.417 454.235 351.926 455.14 352.529C455.744 352.228 456.046 351.926 456.649 351.624L455.14 352.529L517.918 389.653C518.522 389.955 518.823 389.955 519.427 389.653C520.634 389.049 521.54 388.446 522.747 387.842V391.766C522.747 392.671 522.445 393.576 521.842 393.878C522.445 393.576 523.049 393.275 523.351 392.973C523.954 392.671 524.558 392.369 524.86 392.067C525.463 391.766 525.765 391.162 525.765 389.955L526.369 346.191C526.369 344.38 525.162 341.966 523.351 340.759Z",
    fill: "#393244"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M520.035 342.869L454.541 304.237C452.73 303.331 451.221 303.935 451.221 306.047L450.617 349.811C450.617 351.923 452.126 354.338 453.937 355.545L519.431 394.178C521.242 395.083 522.751 394.48 522.751 392.367L523.355 348.603C523.355 346.189 521.846 343.774 520.035 342.869Z",
    fill: "#1B1823"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M462.085 336.832C462.085 335.927 460.576 334.418 460.878 334.116C461.18 333.814 462.387 332.909 459.972 330.494C459.067 329.589 457.86 328.985 456.954 328.382C456.049 327.778 455.143 327.174 453.936 326.571C452.729 325.665 451.823 323.553 451.22 322.043C450.918 322.043 449.107 322.949 448.805 325.363C448.805 326.269 448.503 327.174 448.503 328.08C448.201 329.891 447.598 331.702 447.9 333.512C448.201 334.72 448.503 335.323 448.503 336.531C448.805 340.152 455.143 346.792 456.954 342.869C458.463 342.869 459.369 342.567 459.369 340.756C459.369 340.152 458.161 339.247 458.463 339.247C459.369 338.04 462.085 340.152 462.085 336.832Z",
    fill: "#FFCAAB"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M933.897 857.814L934.189 956.602L941.276 960.787L940.985 861.902L933.897 857.814Z",
    fill: "#BECEF9"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M940.977 861.9L941.268 960.786L948.355 956.6L948.064 857.812L940.977 861.9Z",
    fill: "#98A4E0"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M933.897 857.814L940.985 861.902L948.072 857.814L940.985 853.726L933.897 857.814Z",
    fill: "#37404A"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.99 817.228L1004.38 916.016L1011.37 920.104L1011.07 821.315L1003.99 817.228Z",
    fill: "#BECEF9"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.07 821.316L1011.36 920.104L1018.45 916.017L1018.16 817.228L1011.07 821.316Z",
    fill: "#98A4E0"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.99 817.229L1011.07 821.316L1018.16 817.229L1011.17 813.141L1003.99 817.229Z",
    fill: "#37404A"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M861.079 814.599L861.37 913.387L868.458 917.475L868.166 818.687L861.079 814.599Z",
    fill: "#BECEF9"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M868.158 818.686L868.449 917.474L875.537 913.387L875.245 814.599L868.158 818.686Z",
    fill: "#98A4E0"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M861.079 814.601L868.166 818.689L875.253 814.601L868.166 810.513L861.079 814.601Z",
    fill: "#37404A"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M858.85 804.576L858.947 815.087L940.983 862.973V852.364L858.85 804.576Z",
    fill: "#10191B"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M940.982 852.364V862.973L1023.7 815.087L1023.6 804.576L940.982 852.364Z",
    fill: "#98A4E0"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M858.85 804.575L940.983 852.363L1023.6 804.575L941.469 756.69L858.85 804.575Z",
    fill: "#37404A"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M858.554 676.198L858.845 804.574L865.932 808.662L865.641 680.286L858.554 676.198Z",
    fill: "#BECEF9"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M865.635 680.285L865.926 808.661L873.013 804.573L872.722 676.197L865.635 680.285Z",
    fill: "#98A4E0"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M858.554 676.2L865.641 680.287L872.728 676.2L865.641 672.112L858.554 676.2Z",
    fill: "#EFF6FE"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M933.8 632.792L934.091 761.168L941.081 765.256L940.79 636.88L933.8 632.792Z",
    fill: "#BECEF9"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M940.797 636.881L941.088 765.257L948.175 761.169L947.884 632.793L940.797 636.881Z",
    fill: "#98A4E0"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M933.8 632.793L940.79 636.881L947.877 632.793L940.887 628.706L933.8 632.793Z",
    fill: "#37404A"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M856.428 693.328L856.622 746.177L863.127 750.07L862.932 697.124L856.428 693.328Z",
    fill: "#10191B"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M862.926 697.125L863.12 750.072L956.224 696.152L956.127 643.205L862.926 697.125Z",
    fill: "#242A31"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M856.428 693.328L862.932 697.124L956.134 643.204L949.532 639.408L856.428 693.328Z",
    fill: "#37404A"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M997.786 709.191C994.722 704.261 991.74 698.787 989.642 694.879C989.501 691.816 989.405 688.68 989.307 685.517C988.996 675.427 988.675 665.053 986.891 655.854C983.978 640.768 977.085 624.806 964.464 615.268C962.425 613.71 959.804 612.153 957.183 612.737C954.27 613.321 952.426 616.046 951.067 618.674C948.154 624.416 946.115 629.77 946.212 636.096C946.309 642.325 947.474 648.651 949.513 654.588C951.521 660.469 953.381 666.048 955.14 671.321C958.58 681.637 961.63 690.784 964.628 698.734C963.18 700.009 962.182 701.392 962.138 703.153C962.041 710.939 970.293 723.3 979.516 734.493C979.603 734.404 979.691 734.315 979.778 734.227C985.174 740.626 993.746 747.677 999.849 752.697C1003.05 755.333 1005.58 757.41 1006.6 758.537C1010.29 762.625 1025.53 755.228 1021.94 747.344C1018.16 738.877 1005.24 718.924 998.059 708.997C997.967 709.061 997.876 709.125 997.786 709.191Z",
    fill: "url(#paint84_linear_1419_1910)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.93 918.348C1071.74 924.577 1083.78 932.168 1095.82 939.76C1099.22 941.901 1102.61 942.582 1105.72 945.21C1108.25 947.449 1111.74 951.926 1111.93 955.43C1112.32 960.004 1103.1 963.411 1099.61 964.481C1094.65 966.038 1089.9 966.33 1084.85 965.552C1079.9 964.773 1076.69 962.34 1073.39 958.641C1070.48 955.235 1067.57 951.439 1063.39 949.979C1059.51 948.519 1054.56 949.201 1051.55 946.281C1049.99 944.821 1049.32 942.68 1048.83 940.538C1047.86 936.645 1048.05 932.46 1047.08 928.567C1046.4 925.744 1045.04 922.727 1045.24 919.807C1045.43 917.277 1048.05 915.038 1050.38 914.357C1053 913.578 1055.82 914.162 1058.25 915.428L1058.93 918.348Z",
    fill: "#10191B"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.17 945.696C1015.15 954.553 1025.05 964.481 1034.95 974.506C1037.77 977.328 1040.68 980.248 1043.01 983.46C1044.95 986.088 1047.47 989.689 1046.99 993.193C1046.31 997.67 1036.7 998.935 1033.11 999.227C1028.06 999.616 1023.4 998.935 1018.74 996.988C1014.17 995.139 1011.55 992.122 1009.22 987.742C1007.18 983.849 1005.24 979.567 1001.55 977.133C998.058 974.895 993.301 974.408 990.971 970.904C989.806 969.152 989.612 966.914 989.612 964.773C989.515 960.782 990.583 956.792 990.485 952.899C990.388 949.979 989.806 946.864 990.68 944.042C991.456 941.609 994.466 940.149 996.893 939.954C999.514 939.759 1002.23 940.927 1004.17 942.679V945.696Z",
    fill: "#10191B"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M891.657 731.282C892.337 736.343 892.822 741.502 893.016 746.563C892.725 741.404 892.337 736.343 891.657 731.282Z",
    fill: "#F3A984"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M893.012 746.465C893.206 749.579 893.206 752.694 893.206 755.711C893.109 755.711 893.109 755.614 893.012 755.614C893.109 752.596 893.109 749.579 893.012 746.465Z",
    fill: "#F3A984"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.8 806.225C1077.18 811.091 1085.43 843.307 1056.98 844.475C1042.23 845.059 1028.93 836.786 1015.72 830.265C997.472 821.311 977.958 815.374 959.512 806.906C953.881 804.278 948.25 801.456 943.395 797.563C931.551 788.025 925.046 772.355 926.503 757.269C926.697 755.128 927.085 752.986 928.153 751.137C933.104 742.28 964.269 745.297 971.55 748.899C998.248 762.135 1062.13 801.261 1069.8 806.225Z",
    fill: "#242A31"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.44 829.097C1078.05 836.981 1077.28 844.767 1076.11 852.553C1074.85 861.216 1073.39 869.975 1073 878.735C1072.52 888.176 1073.2 897.616 1073 907.155C1072.91 913.092 1073.1 919.126 1071.55 924.868C1070.77 927.594 1069.9 930.513 1067.47 932.071C1064.56 933.823 1061.06 934.893 1057.76 935.38C1055.43 935.672 1053.01 935.672 1050.87 934.99C1043.39 932.557 1043.1 922.046 1041.65 915.622C1040.29 909.685 1039.22 903.651 1038.44 897.519C1036.89 885.645 1036.31 873.674 1035.63 861.605C1035.24 853.624 1034.85 845.643 1035.14 837.76C1035.43 830.46 1035.63 822.966 1039.03 816.542C1042.33 810.118 1049.8 805.544 1056.69 804.084C1064.46 802.527 1071.94 805.544 1075.82 812.649C1078.15 816.834 1078.93 821.798 1078.64 826.664C1078.54 827.443 1078.54 828.319 1078.44 829.097Z",
    fill: "#242A31"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.08 833.866C1027.78 839.414 1033.51 873.284 1006.52 872.506C992.536 872.116 980.4 862.578 968.265 854.987C929.431 830.46 880.985 821.895 888.364 773.231C889.043 768.754 890.208 749.775 893.703 747.634C896.228 746.076 910.208 751.04 913.315 751.527C943.605 756.588 947.489 756.685 952.44 760.092C953.314 782.866 956.906 786.76 969.333 794.254C975.061 797.758 1016.03 829.681 1021.08 833.866Z",
    fill: "#242A31"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.9 856.447C1025.93 864.33 1024.77 872.019 1023.02 879.708C1021.18 888.273 1019.23 896.838 1018.17 905.597C1017.1 915.038 1017.1 924.479 1016.32 933.92C1015.84 939.76 1015.64 945.891 1013.7 951.439C1012.83 954.067 1011.66 956.987 1009.14 958.349C1006.13 959.907 1002.54 960.783 999.235 960.977C996.905 961.172 994.478 960.977 992.342 960.101C985.061 957.181 985.449 946.67 984.381 940.149C983.41 934.115 982.731 927.983 982.342 921.949C981.566 909.977 981.857 898.006 981.954 885.937C982.051 877.956 982.245 869.975 983.022 862.092C983.798 854.889 984.478 847.395 988.361 841.166C992.051 835.034 999.817 830.947 1006.81 829.973C1014.67 828.903 1021.86 832.407 1025.25 839.803C1027.29 844.183 1027.68 849.147 1027.2 853.916C1027.1 854.792 1027 855.668 1026.9 856.447Z",
    fill: "#37404A"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M891.652 633.273C900.584 627.141 918.545 619.16 936.02 613.71C960.485 606.021 963.981 614.975 970.971 634.538C977.572 652.738 975.631 682.91 972.718 702.278C971.165 712.595 970.194 722.912 969.903 733.326C969.806 737.122 970.582 740.918 971.068 744.714C971.262 746.368 971.844 748.12 971.165 749.677C970.291 751.624 967.476 753.668 965.825 755.03C958.253 761.357 948.544 764.763 938.738 765.542C925.05 766.612 910.196 764.082 897.186 759.897C894.468 759.021 891.555 757.95 889.808 755.614C888.254 753.57 887.769 750.943 887.478 748.509C886.313 740.431 885.633 732.256 885.536 724.08C885.439 720.381 885.536 716.78 885.245 713.082C884.856 707.729 883.691 702.376 882.526 697.12C880.973 689.918 879.323 682.715 877.672 675.416C876.798 671.815 876.022 668.214 875.148 664.612C874.468 661.985 873.4 659.649 873.595 656.923C874.08 646.217 883.497 638.82 891.652 633.273Z",
    fill: "url(#paint85_linear_1419_1910)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M923.69 687.678C928.933 713.373 934.175 739.749 959.029 752.596C960.971 753.57 962.816 754.737 964.563 756.003C957.185 761.648 947.962 764.86 938.738 765.638C925.05 766.709 910.196 764.178 897.186 759.993C894.468 759.117 891.555 758.047 889.808 755.711C888.254 753.667 887.769 751.039 887.478 748.606C886.313 740.528 885.633 732.352 885.536 724.176C885.439 720.478 885.536 716.877 885.245 713.178C884.856 707.825 883.691 702.472 882.526 697.216C880.973 690.014 879.323 682.812 877.672 675.512C876.798 671.911 876.022 668.31 875.148 664.709C874.468 662.081 873.4 659.745 873.595 657.02C873.692 655.56 873.886 654.1 874.371 652.737C878.546 654.489 882.72 656.047 886.895 657.701C901.846 663.541 920.681 671.814 923.69 687.678Z",
    fill: "white"
  }))), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M936.608 744.909C939.229 747.148 942.238 749.775 944.86 752.014C948.549 746.174 948.646 745.688 952.044 739.848C952.141 705.199 950.685 672.691 942.433 639.503C939.326 641.741 937.675 642.909 934.472 645.148C938.646 676.877 941.268 709.968 936.608 744.909Z",
    fill: "#37404A"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M945.924 638.627C945.924 638.725 946.021 638.919 945.924 639.114C945.924 640.087 945.341 641.353 944.953 642.228C944.273 644.175 943.302 646.122 942.234 647.971C941.652 648.944 940.972 650.015 939.904 650.404C938.739 650.891 937.283 650.501 936.215 649.917C934.953 649.236 932.623 648.166 932.817 646.511C933.108 645.148 933.594 643.688 933.982 642.326C934.953 639.601 936.215 636.194 938.739 634.442C941.555 632.593 943.593 635.415 945.147 637.459C945.535 638.043 945.826 638.238 945.924 638.627Z",
    fill: "#283032"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M909.815 624.612C910.01 617.604 914.767 615.852 913.31 602.518C912.825 598.138 907.971 591.715 920.592 591.909C923.99 592.007 927.388 592.785 930.689 593.953C942.436 597.846 944.086 600.766 944.863 625.098C934.863 624.125 926.029 613.029 915.738 619.648C913.019 621.692 911.175 624.32 909.913 627.239C909.815 626.363 909.815 625.487 909.815 624.612Z",
    fill: "#EE9C76"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M915.73 619.647C926.021 613.029 934.856 624.124 944.856 625.097C944.856 625.487 944.856 625.779 944.856 626.168C945.341 643.493 912.429 643.979 909.905 627.239C911.264 624.319 913.012 621.691 915.73 619.647Z",
    fill: "#F5A783"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M938.938 636.583C939.617 638.627 942.335 639.406 944.083 640.574C944.86 641.061 946.219 642.131 947.287 641.937C948.355 641.742 948.937 640.282 949.326 639.503C951.85 633.274 953.306 626.461 953.403 619.648C953.403 617.507 953.112 615.074 951.364 613.614C949.811 612.251 947.287 611.959 945.442 612.738C943.5 613.614 943.015 617.507 943.695 619.356C946.219 625.78 943.403 633.274 938.938 636.583Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M939.226 636.681C939.226 636.681 936.12 641.644 932.236 645.051C931.265 645.927 930.489 646.9 929.227 646.511C923.013 644.564 909.907 633.469 907.383 626.558C906.412 624.028 908.256 620.913 909.616 618.967C909.907 618.578 911.848 615.852 912.237 615.658C912.528 616.047 913.887 621.011 916.023 624.32C921.072 631.62 930.295 635.415 939.226 636.681Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M957.284 563.782C959.808 567.772 961.265 572.444 961.168 577.31C961.168 579.452 960.779 581.593 960.1 583.539C959.42 585.389 958.255 587.238 958.255 589.282C958.255 591.715 960.003 594.44 960.779 596.679C961.459 598.723 961.847 601.058 961.071 603.102C960.585 604.27 959.808 605.244 959.129 606.314C955.925 611.375 958.935 618.772 953.401 622.373C952.042 623.249 950.391 623.444 948.741 623.541C946.605 623.736 937.382 621.108 933.79 619.551C929.809 617.799 925.926 613.224 923.11 610.013C920.877 607.482 917.091 604.173 915.635 601.058C915.149 600.085 916.217 599.988 915.247 599.501C914.664 599.209 913.984 595.511 913.305 595.413C912.528 595.316 911.46 594.44 910.878 594.051C909.616 593.272 909.033 596.289 908.645 594.829C906.897 588.698 904.664 582.469 904.956 575.948C905.15 570.011 905.053 564.95 908.839 559.889C911.654 556.093 915.732 553.368 920.198 551.713C926.994 549.182 934.566 548.988 941.459 551.324C947.964 553.562 953.692 558.039 957.284 563.782Z",
    fill: "#FFBFA2"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M904.956 575.947C905.15 570.01 905.053 564.949 908.839 559.888C911.654 556.092 915.732 553.367 920.198 551.712C924.275 550.155 928.644 549.571 932.916 549.766C939.324 562.71 930.003 579.256 937.091 592.59C939.421 595.705 944.178 598.138 944.178 602.031C945.731 609.136 938.741 615.365 942.624 622.47C939.421 621.594 935.828 620.426 933.887 619.55C929.906 617.798 926.023 613.224 923.207 610.012C920.975 607.481 917.188 604.172 915.732 601.058C915.247 600.084 916.314 599.987 915.344 599.5C914.761 599.208 914.081 595.51 913.402 595.413C912.625 595.315 911.557 594.439 910.975 594.05C909.616 593.271 909.033 596.289 908.645 594.829C906.897 588.697 904.664 582.468 904.956 575.947Z",
    fill: "#F8B495"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M900.88 575.071C900.394 557.844 912.336 554.632 912.336 554.632C912.336 554.632 917.578 545.678 931.461 546.262C938.743 546.651 945.927 548.987 952.043 552.88C952.335 553.075 952.529 553.172 952.82 553.367C955.83 555.314 958.645 557.649 960.587 560.667C965.829 568.842 958.742 575.46 950.102 574.098C946.024 573.417 942.335 571.567 938.452 570.205C935.733 569.231 932.723 568.55 930.102 569.718C927.481 570.886 925.928 573.709 925.539 576.531C924.568 582.76 926.704 588.989 926.898 595.121C926.898 595.997 926.898 596.97 926.413 597.846C925.151 599.987 922.821 598.819 921.559 597.457C920.685 596.581 920.102 595.51 919.229 594.634C918.452 593.758 917.384 592.882 916.219 592.688C914.277 592.298 912.821 593.856 912.53 595.607C912.239 597.262 912.53 598.917 913.015 600.474C913.112 600.766 913.889 603.588 912.724 603.588C911.559 603.686 901.268 593.077 900.88 575.071Z",
    fill: "#37404A"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M934.956 569.232C933.306 569.038 931.558 569.038 930.102 569.719C927.481 570.887 925.928 573.71 925.539 576.532C924.568 582.761 926.704 588.99 926.898 595.122C926.898 595.998 926.898 596.971 926.413 597.847C925.151 599.988 922.821 598.82 921.559 597.458C920.685 596.582 920.102 595.511 919.229 594.635C918.452 593.759 917.384 592.883 916.219 592.689C914.277 592.299 912.821 593.857 912.53 595.608C912.239 597.263 912.53 598.918 913.015 600.475C913.112 600.767 913.889 603.589 912.724 603.589C911.559 603.589 901.268 592.981 900.88 574.975C900.394 557.748 912.336 554.536 912.336 554.536C912.336 554.536 917.384 555.412 923.598 559.597C930.199 563.977 934.956 569.232 934.956 569.232Z",
    fill: "#242A31"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M912.139 600.182C914.469 603.491 918.353 604.853 920.586 603.199C922.916 601.544 922.819 597.456 920.489 594.147C918.159 590.838 914.372 589.476 912.042 591.13C909.712 592.785 909.712 596.873 912.139 600.182Z",
    fill: "#FFBFA2"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M914.276 594.732C913.597 595.511 913.597 596.874 914.374 597.652C915.247 598.625 916.995 598.723 917.577 599.988C917.772 600.475 917.869 601.059 918.257 601.253C918.742 601.448 919.325 600.961 919.325 600.475C919.325 599.891 919.034 599.404 918.645 599.015C918.354 598.625 917.966 598.236 917.772 597.652C917.577 597.166 917.674 596.582 917.674 595.998C917.772 593.954 915.539 593.175 914.276 594.732Z",
    fill: "#F3A984"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M975.734 935.089L976.123 1076.7L985.54 1082.25L985.249 940.637L975.734 935.089Z",
    fill: "#98A4E0"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M985.242 940.637L985.533 1082.25L995.048 1076.7L994.757 935.089L985.242 940.637Z",
    fill: "#C6D5FA"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M975.734 935.089L985.249 940.637L994.763 935.089L985.249 929.542L975.734 935.089Z",
    fill: "#37404A"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M846.121 859.469L846.509 1001.08L855.927 1006.63L855.538 865.017L846.121 859.469Z",
    fill: "#98A4E0"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M855.539 865.017L855.927 1006.63L865.442 1001.08L865.15 859.469L855.539 865.017Z",
    fill: "#C6D5FA"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M846.121 859.468L855.538 865.016L865.15 859.468L855.635 854.017L846.121 859.468Z",
    fill: "#37404A"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.26 804.283L1201.55 945.896L1211.07 951.444L1210.68 809.831L1201.26 804.283Z",
    fill: "#98A4E0"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.67 809.831L1211.06 951.444L1220.58 945.896L1220.29 804.283L1210.67 809.831Z",
    fill: "#C6D5FA"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.26 804.282L1210.68 809.83L1220.29 804.282L1210.78 798.832L1201.26 804.282Z",
    fill: "#37404A"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M846.317 859.467L846.414 870.367L985.44 951.442V940.444L846.317 859.467Z",
    fill: "#98A4E0"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M985.438 940.446V951.444L1220.38 815.282V804.381L985.438 940.446Z",
    fill: "#BECEF9"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M846.317 859.469L985.44 940.446L1220.39 804.381L1081.26 723.306L846.317 859.469Z",
    fill: "#ECF5FE"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.97 789.584V797.857L985.337 853.529L985.434 845.256L1080.97 789.584Z",
    fill: "#10191B"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M985.434 845.257L985.336 853.529L926.018 819.27L926.115 810.9L985.434 845.257Z",
    fill: "#242A31"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.96 789.584L985.433 845.256L926.114 810.899L1021.65 755.227L1080.96 789.584Z",
    fill: "#37404A"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.3 784.23L980.381 799.316L966.207 791.14L992.226 776.054L1006.3 784.23Z",
    fill: "#0D1315"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M952.138 820.145L1039.42 769.339L1070.58 787.345L983.302 838.248L952.138 820.145Z",
    fill: "#0D1315"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.94 767.978C1012.72 769.535 1015.53 773.72 1016.7 774.888C1017.96 776.153 1017.09 770.995 1018.83 770.995C1021.45 771.092 1024.37 772.747 1026.31 771.092C1027.86 769.73 1029.51 768.27 1030.68 766.518C1031.84 764.766 1032.62 762.625 1032.52 760.581C1032.42 759.802 1032.23 758.926 1031.74 758.245C1031.45 757.758 1030.97 757.369 1030.58 757.077C1028.25 755.033 1025.92 752.892 1023.49 750.848C1023.01 750.361 1022.42 749.972 1021.84 749.583C1021.07 749.096 1020.09 748.902 1019.22 748.902C1015.92 748.707 1012.81 750.361 1010.68 752.697C1009.61 753.865 1008.35 755.423 1008.06 756.98C1007.76 758.245 1008.64 759.705 1009.12 760.97C1009.9 763.306 1010.77 765.739 1011.94 767.978Z",
    fill: "#F8B495"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.84 761.651C1008.64 765.058 1008.54 768.561 1008.35 771.968C1008.25 773.33 1008.25 774.596 1008.54 775.958C1008.74 776.932 1009.22 777.905 1009.61 778.878C1009.9 779.754 1010.1 780.727 1010.58 781.506C1011.75 784.134 1014.27 785.788 1016.7 787.248C1017.67 787.832 1018.74 788.514 1019.81 788.708C1020.49 788.806 1021.46 788.708 1021.75 788.027C1021.84 787.735 1021.84 787.346 1021.75 786.956C1021.55 785.983 1021.36 784.913 1020.78 784.134C1020 783.161 1018.84 782.577 1018.06 781.701C1016.7 780.143 1016.6 777.71 1017.28 775.666C1017.96 773.622 1019.13 771.871 1020 769.924C1020.87 767.977 1021.26 765.739 1020.39 763.792C1020.1 763.111 1019.61 762.527 1019.13 761.943C1017.96 760.678 1016.7 759.412 1015.15 758.731C1013.79 758.147 1012.23 757.855 1010.78 758.342C1008.93 758.731 1008.93 760.191 1008.84 761.651Z",
    fill: "#F8B495"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.75 765.935C1022.81 765.059 1018.93 769.244 1018.54 770.412C1017.67 773.137 1020.48 770.899 1023.98 776.349C1025.05 777.906 1026.02 779.561 1026.5 781.41C1026.79 782.773 1026.99 784.427 1028.25 785.011C1029.22 785.4 1030.39 784.914 1030.97 783.941C1031.26 785.887 1034.17 784.33 1034.75 782.383C1035.82 778.685 1038.74 782.091 1039.12 775.57C1039.51 775.765 1039.8 775.862 1040.19 776.057C1044.56 772.456 1035.43 762.042 1031.45 757.954C1024.37 750.557 1022.81 761.847 1024.75 765.935Z",
    fill: "#F8B495"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M966.022 797.566C967.77 798.442 972.236 801.751 973.498 803.211C974.857 804.671 969.129 803.503 969.129 805.45C969.129 808.37 970.876 811.679 968.935 813.82C967.381 815.572 965.634 817.227 963.692 818.492C961.75 819.757 959.323 820.536 956.993 820.341C956.119 820.244 955.149 819.952 954.469 819.465C953.984 819.076 953.595 818.589 953.207 818.102C950.974 815.377 948.741 812.652 946.508 810.024C946.023 809.44 945.537 808.856 945.149 808.175C944.663 807.299 944.469 806.228 944.469 805.158C944.372 801.459 946.314 798.053 949.032 795.717C950.294 794.549 952.139 793.284 953.887 792.992C955.343 792.7 956.896 793.77 958.255 794.257C960.877 795.23 963.498 796.301 966.022 797.566Z",
    fill: "#FFBFA2"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M959.132 793.868C962.918 793.771 966.801 793.771 970.588 793.673C972.044 793.673 973.597 793.673 974.957 794.063C976.025 794.355 977.092 794.939 978.16 795.328C979.131 795.717 980.102 796.009 981.073 796.496C983.888 797.956 985.636 800.778 987.189 803.504C987.869 804.574 988.451 805.742 988.646 807.105C988.743 807.883 988.548 808.954 987.772 809.246C987.383 809.343 986.995 809.246 986.607 809.246C985.539 808.954 984.374 808.759 983.5 807.981C982.432 807.105 981.85 805.742 980.879 804.866C979.131 803.212 976.51 803.114 974.277 803.796C972.044 804.477 970.005 805.742 967.772 806.618C965.539 807.494 963.015 807.883 960.976 806.813C960.2 806.423 959.617 805.839 959.035 805.256C957.675 803.893 956.316 802.433 955.637 800.681C955.054 799.124 954.86 797.372 955.345 795.815C955.831 793.868 957.384 793.868 959.132 793.868Z",
    fill: "#FFBFA2"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M868.785 702.104C872.111 717.127 874.903 729.734 878.068 740.045C878.166 740.366 878.268 740.686 878.373 741.003C878.807 742.938 879.735 745.107 881.052 747.441C882.312 749.896 883.735 752.054 885.226 753.757C898.596 771.753 926.71 795.017 933.693 800.192C937.382 803.014 942.334 806.129 947.091 805.156C950.78 804.377 956.605 799.219 956.605 795.034C956.702 792.503 955.246 790.07 953.79 787.929C945.522 775.713 925.55 754.481 914.235 742.452C911.531 739.577 909.321 737.228 907.884 735.654C907.863 735.396 907.841 735.14 907.819 734.884C907.769 734.295 907.72 733.71 907.678 733.134C907.13 725.792 906.02 718.527 904.911 711.273C903.859 704.391 902.809 697.52 902.242 690.602C900.98 675.224 895.737 658.678 884.184 647.875C882.242 646.026 879.912 644.274 877.194 644.566C874.281 644.76 872.145 647.388 870.495 649.821C866.903 655.175 864.379 660.333 863.796 666.659C863.214 672.986 863.699 679.312 865.058 685.444C866.392 691.296 867.621 696.848 868.785 702.104Z",
    fill: "url(#paint86_linear_1419_1910)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M963.21 811.775C962.24 809.634 967.094 805.352 968.356 805.06C971.366 804.281 968.744 807.201 974.666 811.386C976.414 812.554 978.162 813.819 980.2 814.403C981.657 814.793 983.501 814.987 984.084 816.447C984.569 817.518 983.89 818.783 982.822 819.367C984.957 819.756 983.113 822.968 980.977 823.455C976.802 824.525 980.492 827.835 973.21 828.029C973.404 828.419 973.501 828.808 973.696 829.197C969.521 833.966 958.259 823.357 953.89 818.783C946.124 810.802 958.745 809.44 963.21 811.775Z",
    fill: "#FFBFA2"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.76 732.26L1101.94 736.445C1101.46 736.153 1100.78 736.153 1100 736.64L1092.82 732.455C1093.59 732.065 1094.27 731.968 1094.76 732.26Z",
    fill: "#37404A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1419_1910",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1092,
    y: 732,
    width: 10,
    height: 5
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.76 732.26L1101.94 736.445C1101.46 736.153 1100.78 736.153 1100 736.64L1092.82 732.455C1093.59 732.065 1094.27 731.968 1094.76 732.26Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1419_1910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1100 736.641L1092.82 732.456C1093.11 732.262 1093.4 732.164 1093.69 732.164L1100.88 736.349C1100.49 736.349 1100.29 736.447 1100 736.641Z",
    fill: "#37404A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.78 736.35L1093.69 732.165C1094.08 732.067 1094.47 732.165 1094.76 732.262L1101.94 736.447C1101.56 736.253 1101.17 736.253 1100.78 736.35Z",
    fill: "#37404A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.84 736.446L1094.66 732.261H1094.76L1101.94 736.446H1101.84Z",
    fill: "#37404A"
  }))), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.82 789.197L1002.63 785.012L1092.82 732.454L1100.01 736.639L1009.82 789.197Z",
    fill: "#37404A"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.1 793.869L999.911 789.684C999.911 787.932 1001.17 785.791 1002.63 785.012L1009.81 789.198C1008.26 790.074 1007.1 792.215 1007.1 793.869Z",
    fill: "#37404A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1419_1910",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 999,
    y: 785,
    width: 11,
    height: 9
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.1 793.869L999.911 789.684C999.911 787.932 1001.17 785.791 1002.63 785.012L1009.81 789.198C1008.26 790.074 1007.1 792.215 1007.1 793.869Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1419_1910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1008.46 790.365L1001.27 786.18C1001.66 785.694 1002.15 785.304 1002.63 785.012L1009.81 789.198C1009.33 789.49 1008.84 789.879 1008.46 790.365Z",
    fill: "#37404A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.58 791.826L1000.4 787.641C1000.59 787.155 1000.98 786.571 1001.37 786.181L1008.55 790.367C1008.07 790.853 1007.77 791.34 1007.58 791.826Z",
    fill: "#37404A"
  }))), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M1100 736.639C1101.55 735.763 1102.72 736.444 1102.72 738.196L1080.97 789.586L985.343 845.257L1006.7 793.771C1006.7 793.771 1007.28 790.559 1009.81 789.099L1100 736.639Z",
    fill: "#10191B"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M985.351 845.257L978.264 841.072L1000.4 787.638L1007.58 791.823L985.351 845.257Z",
    fill: "#242A31"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.62 285.774L1117.73 282.408L1196.83 677.04L1202.44 680.406L1123.62 285.774Z",
    fill: "#BFC8D7"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.6 280.726L1126.99 277.361L1117.73 282.409L1123.62 285.775L1132.6 280.726Z",
    fill: "#BFC8D7"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.62 285.778L1202.43 680.409L1211.41 675.08L1132.59 280.729L1123.62 285.778Z",
    fill: "#D9E1EE"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.11 673.679L1189.26 638.339L1194.87 641.424L1128.11 680.13V673.679Z",
    fill: "#BFC8D7"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.11 680.131L1194.87 641.425L1195.99 646.193L1128.11 685.18V680.131Z",
    fill: "#D9E1EE"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.13 629.922L1180.27 594.582L1185.88 597.947L1119.13 636.653V629.922Z",
    fill: "#BFC8D7"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.13 636.658L1185.88 597.952L1187.01 602.44L1119.13 641.426V636.658Z",
    fill: "#D9E1EE"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.02 587.289L1172.16 552.229L1177.77 555.314L1111.02 594.02V587.289Z",
    fill: "#BFC8D7"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.02 594.023L1177.77 555.317L1178.61 559.805L1111.02 598.791V594.023Z",
    fill: "#D9E1EE"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.58 545.218L1163.73 509.878L1169.34 513.244L1102.58 551.949V545.218Z",
    fill: "#BFC8D7"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.58 551.953L1169.34 513.247L1170.18 517.734L1102.58 556.721V551.953Z",
    fill: "#D9E1EE"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.18 503.709L1155.32 468.65L1160.93 471.735L1094.18 510.441V503.709Z",
    fill: "#BFC8D7"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.18 510.444L1160.93 471.738L1162.06 476.226L1094.18 515.493V510.444Z",
    fill: "#D9E1EE"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.77 461.916L1146.92 426.576L1152.53 429.942L1085.77 468.367V461.916Z",
    fill: "#BFC8D7"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.77 468.37L1152.53 429.944L1153.65 434.432L1085.77 473.418V468.37Z",
    fill: "#D9E1EE"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.92 420.127L1139.06 384.787L1144.67 387.872L1077.92 426.578V420.127Z",
    fill: "#BFC8D7"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.92 426.581L1144.67 387.875L1145.51 392.363L1077.92 431.629V426.581Z",
    fill: "#D9E1EE"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.22 378.053L1130.65 342.713L1136.26 346.078L1069.22 384.504V378.053Z",
    fill: "#BFC8D7"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.22 384.508L1136.26 346.082L1137.1 350.57L1069.22 389.556V384.508Z",
    fill: "#D9E1EE"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.08 325.879L1048.47 322.513L1127.28 717.145L1132.89 720.511L1054.08 325.879Z",
    fill: "#BFC8D7"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.05 320.833L1057.44 317.467L1048.47 322.516L1054.08 325.881L1063.05 320.833Z",
    fill: "#BFC8D7"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.08 325.886L1132.89 720.517L1141.87 715.469L1063.05 320.837L1054.08 325.886Z",
    fill: "#D9E1EE"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M1150 272.034C1150.56 270.632 1155.33 268.388 1156.74 267.546C1172.16 259.693 1193.48 301.484 1198.81 312.142C1198.81 312.142 1201.05 329.252 1192.36 334.3C1190.67 335.142 1188.99 335.983 1186.75 336.263C1181.98 337.105 1178.05 333.739 1175.53 329.252C1175.81 328.971 1145.8 282.412 1150 272.034Z",
    fill: "#1B1823"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.22 226.875C1142.97 230.521 1137.93 229.96 1135.68 229.96C1134.56 228.558 1132.88 225.753 1131.19 222.668C1128.39 217.9 1127.83 212.571 1127.55 208.925C1126.99 203.035 1131.76 201.352 1134.84 203.035C1138.49 204.717 1141.29 212.29 1143.82 218.461C1144.94 220.705 1144.38 225.473 1145.22 226.875Z",
    fill: "#FFDFCD"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.01 222.388C1134.01 222.388 1134.29 222.668 1134.01 222.388C1132.61 219.303 1128.96 216.217 1126.15 214.254C1125.03 213.693 1123.07 212.291 1122.51 213.974C1121.95 215.376 1124.47 220.705 1130.36 224.071C1130.92 224.351 1134.57 226.315 1134.29 224.912L1134.01 222.388Z",
    fill: "#FFDFCD"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.51 216.214C1146.63 217.896 1172.99 263.334 1174.68 279.041C1174.96 281.284 1172.71 276.797 1166.54 279.882C1160.37 282.967 1153.92 289.979 1151.12 283.528L1129.8 230.237C1131.2 227.713 1139.05 221.262 1143.26 217.896C1144.66 216.775 1145.51 216.214 1145.51 216.214Z",
    fill: "#1B1823"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.39 299.791L1160.35 308.486L1163.16 317.742C1163.16 317.742 1164.56 318.863 1166.8 319.705C1167.08 319.705 1167.36 319.424 1167.64 319.424C1174.94 315.778 1184.19 310.73 1181.95 305.12V304.84L1178.86 296.986L1177.74 297.547L1158.39 299.791Z",
    fill: "#FFDFCD"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.63 302.875C1186.71 305.96 1186.15 316.618 1185.87 318.301C1185.59 323.069 1184.75 316.338 1180.26 318.301C1176.05 319.984 1171.29 319.984 1166.8 319.143C1164.27 318.582 1163.15 318.301 1161.19 316.618C1159.23 314.655 1158.66 307.643 1160.07 307.363C1161.75 307.082 1166.24 306.521 1168.48 306.241C1172.41 305.399 1180.82 300.07 1183.63 302.875Z",
    fill: "#D7E2E8"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.6 590.927C1201.6 590.927 1203.01 602.988 1198.8 606.634C1197.68 607.475 1193.47 607.195 1188.7 605.231C1185.62 603.829 1182.53 601.305 1179.45 600.183C1170.47 597.098 1168.51 592.33 1165.7 586.439C1159.25 573.257 1173.56 579.428 1182.81 584.757C1192.63 590.366 1201.6 590.927 1201.6 590.927Z",
    fill: "#0B0C0D"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.06 601.028L1191.78 598.784L1200.75 597.662V597.382L1202.72 600.186L1202.44 605.515C1202.44 605.515 1197.67 609.723 1196.83 609.723C1196.55 609.723 1196.55 609.723 1196.27 609.723L1188.13 605.796L1188.41 604.113C1186.73 603.833 1182.24 596.821 1182.24 596.821L1192.06 601.028Z",
    fill: "#0B0C0D"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M1206.36 598.501C1206.08 599.903 1201.87 599.623 1196.82 598.501C1188.69 596.818 1178.03 593.172 1178.03 591.489C1178.03 578.868 1178.31 541.845 1176.91 533.991C1176.07 530.065 1176.35 526.979 1175.79 523.053C1174.67 516.041 1173.26 509.309 1172.42 502.297C1172.14 499.212 1171.58 495.846 1171.3 492.761C1171.02 489.115 1170.46 485.749 1170.18 482.103C1170.18 480.701 1169.9 479.018 1169.62 477.615C1169.34 473.969 1169.06 470.603 1168.78 467.238C1168.78 466.116 1168.78 465.274 1168.5 464.152C1168.5 463.03 1168.5 461.909 1168.5 461.067C1168.5 458.543 1168.78 456.019 1169.06 453.494C1169.34 451.811 1169.9 450.129 1170.46 448.446C1172.14 445.36 1174.39 442.836 1176.63 440.312C1176.91 440.031 1177.19 439.751 1177.47 439.751C1180.28 436.946 1183.08 434.702 1186.45 433.3C1190.09 431.897 1195.14 423.203 1197.95 426.007C1198.51 426.288 1199.07 426.849 1199.63 427.41C1203.84 432.458 1204.96 438.068 1205.8 443.397C1205.8 443.958 1205.8 444.519 1206.08 445.08C1206.36 447.324 1205.52 454.055 1205.52 456.299C1205.52 457.982 1205.52 459.384 1205.24 460.787C1204.96 463.872 1205.52 493.883 1206.36 519.126C1206.36 520.528 1206.36 522.211 1206.64 523.614C1207.2 538.198 1207.76 550.539 1208.04 553.625C1209.17 564.563 1207.2 594.855 1206.36 598.501Z",
    fill: "#1B1823"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.29 567.087C1141.29 567.087 1145.78 578.306 1142.69 583.074C1141.85 584.476 1137.64 585.318 1132.59 584.476C1129.23 584.196 1125.58 582.513 1122.22 582.233C1112.68 581.952 1109.87 577.745 1105.39 572.696C1095.85 562.038 1111.28 563.721 1121.66 566.245C1132.31 569.331 1141.29 567.087 1141.29 567.087Z",
    fill: "#0B0C0D"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.89 580.265L1132.61 578.022L1141.58 576.9V576.619L1143.55 579.424L1142.99 584.192C1142.99 584.192 1138.22 588.399 1137.38 588.399C1137.1 588.399 1137.1 588.399 1136.82 588.399L1128.68 584.473L1128.96 583.631C1127.28 583.351 1125.6 582.79 1123.91 582.229C1123.07 581.948 1122.51 581.668 1121.67 581.668H1121.11L1132.89 580.265Z",
    fill: "#0B0C0D"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.43 565.408C1149.43 568.774 1149.15 572.42 1147.18 575.225C1145.5 577.469 1142.98 578.591 1140.17 578.871C1137.65 579.152 1134.84 578.871 1132.32 578.31C1129.79 578.03 1119.14 574.103 1119.14 573.262C1119.14 571.859 1119.14 570.176 1119.14 568.494C1119.14 552.226 1119.42 524.178 1119.14 508.471C1119.14 507.35 1119.14 505.947 1119.14 505.106C1119.14 495.569 1140.73 483.228 1142.42 487.997C1144.1 493.045 1145.5 497.533 1146.34 502.301C1146.34 502.581 1146.34 502.581 1146.34 502.862C1146.62 504.825 1146.9 507.069 1147.18 509.313C1147.18 509.593 1147.18 510.154 1147.18 510.435C1148.02 518.849 1148.87 527.544 1149.15 535.958C1149.71 545.775 1149.43 555.592 1149.43 565.408Z",
    fill: "#28222F"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M1197.67 441.994C1196.83 450.97 1172.43 482.664 1168.78 486.59C1161.77 493.883 1153.92 501.456 1148.31 509.309C1148.03 509.59 1147.75 509.87 1147.47 510.431C1146.91 510.992 1146.63 511.272 1146.35 511.833C1146.07 512.114 1145.79 512.675 1145.5 512.955C1144.94 514.077 1144.1 515.199 1142.98 516.882C1142.98 517.162 1142.7 517.162 1142.7 517.443C1141.58 519.406 1121.66 512.394 1119.14 508.468C1118.86 508.187 1118.86 507.907 1118.86 507.626C1118.86 496.407 1124.19 485.468 1125.03 483.225C1125.87 480.981 1126.99 478.176 1128.4 475.371C1131.48 468.64 1135.69 457.421 1140.18 445.921C1143.26 438.348 1146.35 430.775 1149.43 424.324C1149.43 424.324 1201.32 408.057 1197.67 441.994Z",
    fill: "#28222F"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.77 387.298C1139.05 398.237 1137.93 428.248 1137.65 437.784C1137.65 439.747 1138.49 441.43 1140.18 442.272C1144.66 445.077 1148.87 446.198 1153.64 447.04C1155.6 447.601 1157.85 447.601 1160.37 447.881C1169.91 448.442 1180 447.881 1189.26 446.198C1196.27 444.796 1202.72 442.272 1207.77 437.784C1208.89 436.943 1209.74 435.26 1209.74 433.857C1209.74 423.48 1203.85 395.152 1203.56 384.213C1203 365.14 1209.45 332.886 1208.61 322.508C1208.05 313.533 1204.69 302.874 1185.33 305.679L1160.09 311.85C1154.76 314.935 1132.88 319.423 1130.92 332.325C1130.92 332.325 1131.76 337.093 1132.88 343.824C1134.57 353.641 1136.81 368.226 1137.93 378.884C1138.21 382.25 1138.49 385.054 1138.77 387.298Z",
    fill: "#30273B"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.88 296.147C1151.13 299.513 1154.21 302.318 1157.86 303.44C1159.26 304.001 1160.66 304.001 1162.06 304.001C1162.34 304.001 1162.63 304.001 1162.91 304.001C1164.31 304.001 1165.71 303.44 1166.55 302.598C1168.52 300.916 1177.21 300.916 1177.77 298.391C1177.77 297.83 1177.77 297.269 1177.77 296.708C1177.77 290.257 1171.6 281.282 1169.64 275.673C1167.67 270.063 1163.47 265.856 1158.42 262.771C1154.21 259.966 1149.44 258.283 1144.39 257.722L1142.71 261.088L1141.03 263.612C1142.99 268.941 1143.55 274.551 1144.11 280.16C1144.96 285.77 1146.08 291.379 1148.88 296.147Z",
    fill: "#FFDFCD"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.92 262.77C1139.04 266.135 1141.85 265.294 1144.09 267.818C1146.62 270.903 1147.46 273.708 1149.98 276.793C1150.82 277.915 1151.67 280.72 1154.75 278.196C1159.24 274.269 1160.08 296.988 1170.18 300.073C1171.86 300.634 1176.07 299.232 1177.75 298.39C1178.87 298.11 1179.43 297.268 1179.99 296.146C1179.99 296.146 1179.99 296.146 1179.99 295.866C1181.96 292.5 1190.09 281.842 1191.21 276.793C1192.62 272.586 1192.05 267.538 1191.21 263.05C1190.37 258.843 1187.29 255.477 1184.48 252.672C1181.4 249.587 1178.03 247.343 1174.1 245.941C1167.37 243.697 1158.96 244.819 1151.95 247.063C1150.82 247.343 1149.98 247.624 1149.14 247.904C1147.74 248.465 1146.06 249.307 1144.65 249.868C1144.09 250.429 1143.25 250.99 1142.69 251.551C1136.52 256.319 1137.36 260.245 1137.36 260.526C1137.36 260.526 1137.64 262.209 1137.92 262.77Z",
    fill: "#2B0D04"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.76 278.196C1153.36 281.001 1153.92 284.086 1155.88 284.927C1157.85 286.049 1160.65 284.647 1162.33 281.842C1163.74 279.037 1163.18 275.952 1161.21 274.83C1158.97 273.989 1156.16 275.391 1154.76 278.196Z",
    fill: "#FFDFCD"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.73 279.039C1156.17 280.442 1156.17 281.844 1157.29 282.125C1158.13 282.685 1159.54 282.125 1160.1 280.722C1160.66 279.32 1160.66 277.917 1159.54 277.637C1158.69 277.356 1157.57 277.917 1156.73 279.039Z",
    fill: "#FFDFCD"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.32 309.33C1160.92 309.61 1159.24 310.171 1157.83 310.732C1156.99 311.013 1155.87 312.696 1155.87 313.818C1161.76 314.94 1172.7 312.415 1178.87 311.293C1183.92 310.452 1188.97 306.806 1189.81 305.684C1191.49 302.038 1179.15 305.964 1177.75 306.245C1172.7 307.928 1167.37 307.928 1162.32 309.33Z",
    fill: "#30273B"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1187.02 265.016C1189.55 273.711 1187.58 283.808 1181.97 291.1C1181.13 292.222 1180.01 293.344 1180.01 294.747C1180.01 295.027 1180.01 295.307 1180.01 295.307C1181.97 292.222 1189.83 281.284 1190.95 276.235C1192.07 271.747 1191.23 266.699 1190.39 262.211C1189.27 258.004 1185.9 254.919 1183.09 252.114C1180.01 249.029 1176.64 246.785 1172.44 245.663C1165.71 243.7 1157.29 244.822 1150.56 247.065C1156.45 246.224 1162.34 245.383 1167.95 246.785C1176.92 248.748 1184.5 256.041 1187.02 265.016Z",
    fill: "#2B0D04"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.18 386.187C1102.02 387.87 1103.14 389.553 1105.11 390.675C1108.75 393.479 1111 394.321 1118.29 394.882L1160.64 340.75C1160.64 340.75 1169.34 328.97 1159.52 320.836C1157.84 319.714 1155.59 318.592 1153.07 317.751C1146.9 315.787 1141.57 318.872 1137.36 324.202L1105.95 368.517C1105.95 368.517 1099.22 381.98 1101.18 386.187Z",
    fill: "#393244"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.51 356.736C1068.36 357.858 1070.04 358.139 1071.16 357.297C1072.28 356.456 1072.56 354.773 1071.72 353.651L1063.31 342.152C1062.47 341.03 1060.78 340.749 1059.66 341.591C1058.54 342.432 1058.26 343.835 1059.1 345.237L1067.51 356.736Z",
    fill: "#FFDFCD"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.85 357.016L1065.28 347.76L1057.42 342.151C1056.58 341.59 1052.93 339.065 1050.41 340.187C1048.73 341.029 1040.59 346.077 1042.84 348.602C1044.24 350.285 1058.82 362.065 1058.82 362.065C1059.67 362.906 1061.35 366.272 1062.19 366.552L1068.36 368.516L1072.85 357.016Z",
    fill: "#FFDFCD"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.14 362.905C1058.82 364.307 1094.72 394.038 1111.83 396.281C1114.35 396.562 1116.88 396.001 1118.28 395.159C1118.28 395.159 1117.44 391.233 1116.88 387.867C1116.6 383.94 1116.04 380.014 1115.76 379.733L1120.52 372.16L1070.6 349.442C1067.79 351.125 1057.14 362.905 1057.14 362.905Z",
    fill: "#393244"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.051 339.14L359.777 302.06L341.74 294.427L330.051 339.14Z",
    fill: "#D0D9EE"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.715 305.412L331.169 338.404L382.191 305.055L368.715 305.412Z",
    fill: "#D0D9EE"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.713 305.41L357.902 288.254L359.768 302.058L330.041 339.139L331.166 338.402L368.713 305.41Z",
    fill: "#AAB9DE"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.907 288.256L351.776 298.677L359.772 302.061L357.907 288.256Z",
    fill: "#8D9FCA"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.082 291.142C364.229 291.924 365.399 293.03 366.113 292.379C366.535 292.024 366.947 291.66 367.352 291.286C368.132 290.566 367.043 289.378 366.262 290.102C365.87 290.453 365.482 290.8 365.082 291.142ZM483.855 239.946C484.775 240.652 485.66 239.303 484.892 238.715L483.636 237.678C482.752 237.004 481.822 238.32 482.628 238.935L483.855 239.946ZM478.796 236.105C479.743 236.698 480.541 235.302 479.693 234.763C479.239 234.462 478.78 234.164 478.321 233.87C477.427 233.306 476.565 234.667 477.469 235.24C477.918 235.52 478.353 235.81 478.796 236.105ZM473.333 232.881C474.274 233.36 475.007 231.928 474.058 231.443C473.574 231.199 473.081 230.953 472.587 230.72C471.707 230.272 470.897 231.666 471.911 232.183C472.387 232.405 472.856 232.638 473.333 232.881ZM467.512 230.342C468.631 230.685 468.979 229.108 468.063 228.829C467.544 228.642 467.036 228.465 466.514 228.294C465.463 227.971 465.035 229.525 466.015 229.824C466.516 229.991 467.017 230.163 467.512 230.342ZM461.433 228.553C462.557 228.758 462.756 227.157 461.789 226.978C461.255 226.855 460.723 226.744 460.187 226.637C459.123 226.442 458.859 228.032 459.883 228.221C460.403 228.325 460.918 228.437 461.433 228.553ZM455.176 227.517C456.159 227.649 456.455 226.064 455.333 225.913C454.788 225.855 454.249 225.81 453.706 225.769C452.542 225.744 452.63 227.356 453.594 227.376C454.117 227.414 454.647 227.462 455.176 227.517ZM448.835 227.231C449.821 227.247 449.941 225.64 448.81 225.621C448.263 225.625 447.721 225.647 447.176 225.663C446.009 225.784 446.301 227.372 447.247 227.277C447.772 227.252 448.3 227.237 448.835 227.231ZM442.486 227.665C443.499 227.564 443.395 225.953 442.287 226.067C441.746 226.135 441.201 226.206 440.662 226.286C439.72 226.382 439.748 227.997 440.92 227.877L442.486 227.665ZM436.229 228.785C437.249 228.552 436.91 226.973 435.859 227.218C435.33 227.337 434.803 227.47 434.28 227.607C433.309 227.827 433.592 229.418 434.685 229.164C435.2 229.029 435.718 228.904 436.229 228.785ZM430.12 230.544C431.142 230.169 430.565 228.671 429.588 229.024C429.074 229.2 428.564 229.381 428.052 229.575C427.083 229.929 427.603 231.455 428.621 231.08C429.119 230.893 429.616 230.714 430.12 230.544ZM424.221 232.917C425.224 232.406 424.425 231.008 423.532 231.459C423.039 231.684 422.553 231.92 422.066 232.163C421.101 232.647 421.849 234.074 422.779 233.605C423.26 233.369 423.737 233.14 424.221 232.917ZM418.597 235.879C419.545 235.251 418.583 233.954 417.761 234.5C417.289 234.779 416.829 235.061 416.371 235.351C415.457 235.952 416.376 237.282 417.24 236.71C417.688 236.427 418.138 236.153 418.597 235.879ZM413.326 239.426C414.138 238.837 413.247 237.49 412.339 238.151C411.908 238.483 411.48 238.82 411.056 239.161C410.666 239.521 410.692 239.934 410.901 240.228L410.634 240.233C409.463 240.349 409.767 241.939 410.7 241.845C411.228 241.834 411.746 241.829 412.269 241.842C413.325 241.861 413.366 240.254 412.298 240.229L413.326 239.426ZM408.541 243.576C408.17 243.947 407.798 244.327 407.441 244.713C406.757 245.482 405.526 244.441 406.252 243.625C406.623 243.224 407.011 242.831 407.397 242.445C408.25 241.663 409.255 242.924 408.541 243.576ZM404.444 248.371C405.047 247.588 403.814 246.539 403.129 247.441C402.807 247.887 402.505 248.349 402.21 248.813C401.632 249.721 403.008 250.565 403.566 249.675C403.849 249.23 404.135 248.795 404.444 248.371ZM401.409 253.824C401.805 252.882 400.34 252.218 399.911 253.23C399.703 253.75 399.518 254.282 399.349 254.812C399.041 255.828 400.58 256.296 400.893 255.281C401.05 254.794 401.22 254.301 401.409 253.824ZM400.163 259.795C400.182 258.789 398.576 258.69 398.555 259.808C398.554 260.384 398.587 260.936 398.645 261.504C398.749 262.527 400.357 262.409 400.245 261.315C400.189 260.805 400.164 260.308 400.163 259.795ZM401.576 265.604C401.134 264.734 399.651 265.368 400.171 266.394C400.445 266.895 400.735 267.377 401.066 267.842C401.689 268.701 402.996 267.749 402.372 266.898C402.077 266.494 401.815 266.041 401.576 265.604ZM405.534 270.286C404.643 269.611 403.716 270.831 404.482 271.51C404.9 271.877 405.313 272.221 405.751 272.566C406.609 273.219 407.573 271.926 406.737 271.293C406.328 270.97 405.931 270.632 405.534 270.286ZM410.667 273.764C409.787 273.32 408.977 274.71 409.992 275.227C410.505 275.472 411.004 275.681 411.533 275.882C412.668 276.227 412.996 274.648 412.091 274.37C411.606 274.185 411.142 273.99 410.667 273.764ZM416.555 275.284C415.465 275.263 415.466 276.873 416.505 276.893C417.068 276.917 417.646 276.902 418.213 276.855C419.29 276.749 419.101 275.145 418.066 275.25C417.574 275.297 417.051 275.305 416.555 275.284ZM422.453 274.111C421.44 274.625 422.248 276.02 423.133 275.572C423.642 275.345 424.158 275.078 424.636 274.791C425.498 274.227 424.802 272.909 423.809 273.409C423.381 273.671 422.912 273.909 422.453 274.111ZM427.397 270.547C426.662 271.374 427.902 272.404 428.577 271.642C428.959 271.231 429.329 270.817 429.674 270.375C430.337 269.511 429.034 268.553 428.406 269.382C428.098 269.78 427.744 270.171 427.397 270.547ZM430.854 265.444C430.406 266.319 431.8 267.133 432.317 266.115C432.557 265.605 432.767 265.098 432.968 264.573C433.313 263.443 431.73 263.106 431.457 264.015C431.275 264.497 431.07 264.976 430.854 265.444ZM432.558 259.521C432.422 260.532 434.012 260.795 434.159 259.702C434.227 259.147 434.264 258.581 434.282 258.026C434.305 256.949 432.693 256.933 432.675 257.985C432.657 258.491 432.623 259.01 432.558 259.521ZM432.156 253.435C432.365 254.371 433.969 254.132 433.701 252.999C433.555 252.453 433.375 251.91 433.164 251.382C432.828 250.454 431.286 250.92 431.673 251.99C431.864 252.465 432.02 252.954 432.156 253.435ZM429.318 248.112C430.065 248.926 431.214 247.797 430.527 247.048C430.164 246.628 429.747 246.203 429.331 245.829C428.533 245.119 427.466 246.329 428.258 247.029C428.631 247.363 428.99 247.732 429.318 248.112ZM424.459 244.468C425.347 244.921 426.149 243.522 425.142 243.01C424.633 242.766 424.136 242.545 423.607 242.343C422.54 242.018 422.082 243.451 423.033 243.848C423.518 244.038 423.989 244.243 424.459 244.468ZM418.517 242.58C419.59 242.773 419.84 241.185 418.829 240.998C418.288 240.89 417.75 240.791 417.211 240.701C416.155 240.557 415.904 242.099 416.96 242.293C417.487 242.382 418.005 242.477 418.517 242.58ZM406.057 242.399C407.085 242.163 406.729 240.59 405.696 240.829C405.154 240.95 404.611 241.08 404.083 241.242C402.981 241.644 403.657 243.109 404.546 242.783C405.042 242.633 405.555 242.511 406.057 242.399ZM400.232 244.552C401.131 244.094 400.459 242.63 399.466 243.134C398.986 243.379 398.48 243.69 398.027 243.977C397.113 244.578 398.032 245.908 398.891 245.335C399.323 245.07 399.785 244.781 400.232 244.552ZM395.194 248.2C395.964 247.491 394.89 246.289 394.095 247.023C393.696 247.389 393.283 247.783 392.909 248.175C392.218 248.809 393.199 250.096 394.072 249.292C394.426 248.922 394.809 248.553 395.194 248.2ZM390.997 252.899C391.629 252.063 390.361 251.074 389.709 251.928C389.377 252.364 389.061 252.803 388.745 253.246C388.145 254.034 389.374 255.083 390.056 254.176C390.366 253.748 390.676 253.321 390.997 252.899ZM387.472 258.187C388.016 257.332 386.679 256.427 386.088 257.362L385.269 258.763C384.74 259.8 386.232 260.426 386.669 259.565C386.933 259.109 387.199 258.641 387.472 258.187ZM384.375 263.784C384.861 262.823 383.418 262.109 382.944 263.043L382.207 264.474C381.721 265.427 383.158 266.157 383.639 265.207L384.375 263.784ZM381.467 269.521C381.94 268.587 380.51 267.842 380.024 268.799L379.299 270.237C378.824 271.174 380.254 271.92 380.744 270.964L381.467 269.521ZM378.537 275.284C379.03 274.316 377.576 273.613 377.108 274.535L376.357 275.952C375.853 276.939 377.315 277.618 377.775 276.716L378.537 275.284ZM375.37 280.953C375.916 280.086 374.577 279.193 373.988 280.12L373.155 281.473C372.577 282.385 373.953 283.229 374.511 282.339L375.37 280.953ZM371.73 286.379C372.372 285.537 371.094 284.558 370.451 285.405C370.14 285.816 369.809 286.248 369.475 286.647C368.78 287.556 370.117 288.456 370.712 287.672C371.063 287.247 371.407 286.813 371.73 286.379Z",
    fill: "#8D9FCA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1419_1910",
    x1: 1039.35,
    y1: 511.381,
    x2: 592.254,
    y2: 975.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1419_1910",
    x1: 1355.63,
    y1: 776.433,
    x2: 1121.57,
    y2: 618.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1419_1910",
    x1: 262.95,
    y1: 417.322,
    x2: 428.571,
    y2: 416.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1419_1910",
    x1: 1034.96,
    y1: 809.769,
    x2: 886.566,
    y2: 1036.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1419_1910",
    x1: 146.315,
    y1: 718.116,
    x2: 302.631,
    y2: 633.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1419_1910",
    x1: 1131.5,
    y1: 854.942,
    x2: 1070.93,
    y2: 1018.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1419_1910",
    x1: 35.8187,
    y1: 1034.25,
    x2: 437.899,
    y2: 831.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744582,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1419_1910",
    x1: -1.0131,
    y1: 923.76,
    x2: 133.162,
    y2: 568.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1419_1910",
    x1: 158.594,
    y1: 576.928,
    x2: 367.498,
    y2: 505.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1419_1910",
    x1: 1367.9,
    y1: 386.63,
    x2: 1155.59,
    y2: 457.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1419_1910",
    x1: 891.554,
    y1: 907.665,
    x2: 871.35,
    y2: 928.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1419_1910",
    x1: 1255.86,
    y1: 658.062,
    x2: 1235.65,
    y2: 679.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1419_1910",
    x1: 340.496,
    y1: 933.855,
    x2: 320.581,
    y2: 954.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1419_1910",
    x1: 262.948,
    y1: 1110.99,
    x2: 523.838,
    y2: 1030.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1419_1910",
    x1: 1484.54,
    y1: 392.769,
    x2: 1014.78,
    y2: 352.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1419_1910",
    x1: 389.487,
    y1: 659.074,
    x2: 369.148,
    y2: 680.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1419_1910",
    x1: 1300.19,
    y1: 296.626,
    x2: 1121.92,
    y2: 397.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1419_1910",
    x1: 993.506,
    y1: 568.063,
    x2: 1159.52,
    y2: 568.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#D9E1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AABAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1419_1910",
    x1: 887.144,
    y1: 632.62,
    x2: 887.144,
    y2: 424.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1419_1910",
    x1: 886.542,
    y1: 448.633,
    x2: 886.542,
    y2: 609.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1419_1910",
    x1: 928.424,
    y1: 481.607,
    x2: 1786.41,
    y2: 583.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#E4E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C2DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1419_1910",
    x1: 993.578,
    y1: 442.892,
    x2: 1156.81,
    y2: 459.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C40F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1419_1910",
    x1: 993.506,
    y1: 445.354,
    x2: 1159.52,
    y2: 445.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#D9E1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AABAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1419_1910",
    x1: 887.144,
    y1: 509.91,
    x2: 887.144,
    y2: 301.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1419_1910",
    x1: 886.542,
    y1: 325.923,
    x2: 886.542,
    y2: 486.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1419_1910",
    x1: 928.424,
    y1: 358.901,
    x2: 1786.41,
    y2: 460.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#E4E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C2DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1419_1910",
    x1: 993.578,
    y1: 318.843,
    x2: 1156.81,
    y2: 335.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C40F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1419_1910",
    x1: 993.506,
    y1: 323.849,
    x2: 1159.52,
    y2: 323.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#D9E1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AABAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1419_1910",
    x1: 887.144,
    y1: 388.398,
    x2: 887.144,
    y2: 180.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1419_1910",
    x1: 886.542,
    y1: 204.411,
    x2: 886.542,
    y2: 365.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1419_1910",
    x1: 929.643,
    y1: 227.149,
    x2: 1787.63,
    y2: 329.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#E4E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C2DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1419_1910",
    x1: 993.578,
    y1: 199.022,
    x2: 1156.81,
    y2: 215.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C40F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1419_1910",
    x1: 993.506,
    y1: 201.458,
    x2: 1159.52,
    y2: 201.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#D9E1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AABAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1419_1910",
    x1: 887.144,
    y1: 266.008,
    x2: 887.144,
    y2: 57.7522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1419_1910",
    x1: 886.542,
    y1: 82.0213,
    x2: 886.542,
    y2: 242.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1419_1910",
    x1: 929.643,
    y1: 104.757,
    x2: 1787.63,
    y2: 206.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#E4E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C2DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1419_1910",
    x1: 791.382,
    y1: 686.522,
    x2: 957.37,
    y2: 684.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#D9E1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AABAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1419_1910",
    x1: 685.963,
    y1: 752.64,
    x2: 682.881,
    y2: 544.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1419_1910",
    x1: 682.613,
    y1: 568.686,
    x2: 684.99,
    y2: 729.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1419_1910",
    x1: 725,
    y1: 601.038,
    x2: 1584.41,
    y2: 690.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#E4E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C2DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1419_1910",
    x1: 790.776,
    y1: 559.27,
    x2: 953.431,
    y2: 575.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C40F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1419_1910",
    x1: 587.968,
    y1: 539.97,
    x2: 802.626,
    y2: 564.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C40F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1419_1910",
    x1: 789.576,
    y1: 563.829,
    x2: 955.564,
    y2: 561.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#D9E1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AABAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1419_1910",
    x1: 684.155,
    y1: 629.946,
    x2: 681.073,
    y2: 421.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1419_1910",
    x1: 680.808,
    y1: 445.992,
    x2: 683.185,
    y2: 606.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1419_1910",
    x1: 723.195,
    y1: 478.342,
    x2: 1582.6,
    y2: 567.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#E4E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C2DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1419_1910",
    x1: 788.69,
    y1: 435.22,
    x2: 951.658,
    y2: 451.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C40F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1419_1910",
    x1: 586.175,
    y1: 415.92,
    x2: 800.833,
    y2: 440.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C40F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1419_1910",
    x1: 787.756,
    y1: 442.331,
    x2: 953.745,
    y2: 439.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#D9E1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AABAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1419_1910",
    x1: 682.348,
    y1: 508.456,
    x2: 679.266,
    y2: 300.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1419_1910",
    x1: 679.001,
    y1: 324.502,
    x2: 681.379,
    y2: 485.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1419_1910",
    x1: 722.453,
    y1: 346.595,
    x2: 1581.86,
    y2: 435.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#E4E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C2DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1419_1910",
    x1: 787.144,
    y1: 315.401,
    x2: 949.798,
    y2: 331.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C40F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1419_1910",
    x1: 584.329,
    y1: 296.101,
    x2: 798.987,
    y2: 320.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C40F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1419_1910",
    x1: 785.962,
    y1: 319.952,
    x2: 951.95,
    y2: 317.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#D9E1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AABAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1419_1910",
    x1: 680.551,
    y1: 386.076,
    x2: 677.469,
    y2: 177.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1419_1910",
    x1: 677.198,
    y1: 202.125,
    x2: 679.575,
    y2: 362.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1419_1910",
    x1: 720.656,
    y1: 224.215,
    x2: 1580.06,
    y2: 313.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#E4E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C2DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1419_1910",
    x1: 573.424,
    y1: 818.256,
    x2: 739.435,
    y2: 818.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#D9E1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AABAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1419_1910",
    x1: 467.058,
    y1: 882.812,
    x2: 467.058,
    y2: 674.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1419_1910",
    x1: 466.452,
    y1: 698.824,
    x2: 466.452,
    y2: 859.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1419_1910",
    x1: 508.337,
    y1: 731.803,
    x2: 1366.33,
    y2: 833.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#E4E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C2DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1419_1910",
    x1: 573.454,
    y1: 693.097,
    x2: 736.682,
    y2: 709.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C40F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1419_1910",
    x1: 372.438,
    y1: 668.764,
    x2: 584.707,
    y2: 692.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C40F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1419_1910",
    x1: 573.424,
    y1: 695.549,
    x2: 739.435,
    y2: 695.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#D9E1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AABAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1419_1910",
    x1: 467.058,
    y1: 760.108,
    x2: 467.058,
    y2: 551.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1419_1910",
    x1: 466.452,
    y1: 576.117,
    x2: 466.452,
    y2: 736.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1419_1910",
    x1: 508.337,
    y1: 609.095,
    x2: 1366.33,
    y2: 711.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#E4E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C2DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1419_1910",
    x1: 573.454,
    y1: 569.048,
    x2: 736.682,
    y2: 585.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C40F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1419_1910",
    x1: 372.438,
    y1: 544.715,
    x2: 584.707,
    y2: 568.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C40F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1419_1910",
    x1: 573.424,
    y1: 574.045,
    x2: 739.435,
    y2: 574.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#D9E1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AABAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1419_1910",
    x1: 467.058,
    y1: 638.596,
    x2: 467.058,
    y2: 430.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1419_1910",
    x1: 466.452,
    y1: 454.609,
    x2: 466.452,
    y2: 615.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1419_1910",
    x1: 509.556,
    y1: 477.347,
    x2: 1367.54,
    y2: 579.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#E4E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C2DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1419_1910",
    x1: 573.454,
    y1: 449.227,
    x2: 736.599,
    y2: 465.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18029D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C40F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1419_1910",
    x1: 372.438,
    y1: 424.887,
    x2: 584.707,
    y2: 448.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C40F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1419_1910",
    x1: 573.424,
    y1: 451.653,
    x2: 739.435,
    y2: 451.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#D9E1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AABAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1419_1910",
    x1: 467.058,
    y1: 516.202,
    x2: 467.058,
    y2: 307.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1419_1910",
    x1: 466.452,
    y1: 332.214,
    x2: 466.452,
    y2: 492.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1419_1910",
    x1: 509.556,
    y1: 354.953,
    x2: 1367.54,
    y2: 456.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510204,
    stopColor: "#E4E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C2DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1419_1910",
    x1: 561.478,
    y1: 483.289,
    x2: 464.1,
    y2: 474.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000F57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1419_1910",
    x1: 589.226,
    y1: 455.195,
    x2: 397.778,
    y2: 401.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000F57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1419_1910",
    x1: 518.058,
    y1: 319.049,
    x2: 612.796,
    y2: 319.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C40F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9833,
    stopColor: "#03F8FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1419_1910",
    x1: 584.171,
    y1: 295.457,
    x2: 614.539,
    y2: 295.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C40F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9833,
    stopColor: "#03F8FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1419_1910",
    x1: 945.825,
    y1: 686.165,
    x2: 1021.81,
    y2: 686.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C40F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9833,
    stopColor: "#03F8FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1419_1910",
    x1: 873.058,
    y1: 688.386,
    x2: 974.515,
    y2: 688.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C40F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9833,
    stopColor: "#03F8FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1419_1910",
    x1: 913.646,
    y1: 754.948,
    x2: 889.091,
    y2: 653.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C40F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9833,
    stopColor: "#03F8FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureNew2);
export default __webpack_public_path__ + "static/media/feature-new-2.5bd18773daff0e344806d400047e66bf.svg";
export { ForwardRef as ReactComponent };